// Training details data - separated to avoid babel plugin issues
export const trainingDetails = {
  9: {
    summary: 'Advanced web penetration testing course covering modern web application security vulnerabilities beyond the basics. Hands-on labs with real-world attack scenarios.',
    topics: [
      'Advanced Web Exploitation Techniques',
      'API Security Testing',
      'JavaScript-based Attacks',
      'Authentication & Authorization Bypasses',
      'Business Logic Vulnerabilities',
      'Advanced Burp Suite Usage'
    ],
    suitableFor: [
      'Experienced penetration testers',
      'Security researchers',
      'Web application security professionals',
      'Developers focused on security'
    ],
    benefits: [
      'Advanced exploitation techniques',
      'Real-world attack scenarios',
      'Lab environment access',
      'Certificate of completion',
      'Network with security professionals'
    ],
  },
  10: {
    summary: 'Advanced threat hunting course using memory forensics and endpoint telemetry to detect and investigate sophisticated threats in enterprise environments.',
    topics: [
      'Memory Forensics Fundamentals',
      'Endpoint Telemetry Analysis',
      'Log Analysis & Correlation',
      'Threat Hunting Methodology',
      'Incident Investigation',
      'Detection Rule Development'
    ],
    suitableFor: [
      'SOC analysts and managers',
      'Threat hunters',
      'Incident response teams',
      'Security engineers'
    ],
    benefits: [
      'Advanced forensic analysis skills',
      'Hands-on memory analysis',
      'Real incident scenarios',
      'Detection automation knowledge',
      'Industry expert instruction'
    ],
  },
  11: {
    summary: 'Deep dive into Kubernetes security covering attack vectors, defensive measures, and mitigation strategies for containerized environments.',
    topics: [
      'Kubernetes Architecture & Security Model',
      'Container Escape Techniques',
      'RBAC & Network Policies',
      'Secrets Management',
      'Supply Chain Security',
      'Runtime Security & Monitoring'
    ],
    suitableFor: [
      'DevOps engineers',
      'Cloud security professionals',
      'Kubernetes administrators',
      'Container security specialists'
    ],
    benefits: [
      'Comprehensive Kubernetes security knowledge',
      'Attack and defense scenarios',
      'Best practices from industry experts',
      'Hands-on lab environment',
      'Real-world security strategies'
    ],
  },
  12: {
    summary: 'Master red teaming techniques targeting Active Directory and Azure Entra ID. Learn post-exploitation, lateral movement, and persistence mechanisms.',
    topics: [
      'Active Directory Enumeration & Exploitation',
      'Kerberos Attacks',
      'Azure Entra ID Attacks',
      'Lateral Movement Techniques',
      'Privilege Escalation',
      'Evasion & Defense Bypass'
    ],
    suitableFor: [
      'Red team operators',
      'Penetration testers',
      'Security consultants',
      'Purple team members'
    ],
    benefits: [
      'Real-world red team techniques',
      'Active Directory deep knowledge',
      'Cloud identity security expertise',
      'Advanced evasion methods',
      'Hands-on attack simulations'
    ],
  },
  13: {
    summary: 'Learn exploitation techniques for AWS and Google Cloud misconfigurations. Discover how attackers exploit cloud environments and how to defend against them.',
    topics: [
      'AWS IAM & Bucket Misconfigurations',
      'Google Cloud Security Issues',
      'API Exploitation',
      'Network Exploitation',
      'Data Exfiltration Techniques',
      'Lateral Movement in Cloud'
    ],
    suitableFor: [
      'Cloud security professionals',
      'Penetration testers',
      'DevSecOps engineers',
      'Cloud architects'
    ],
    benefits: [
      'Multi-cloud exploitation knowledge',
      'Real-world attack scenarios',
      'Cloud defense strategies',
      'Hands-on lab access',
      'Industry expert mentorship'
    ],
  },
  14: {
    summary: 'Comprehensive training on attacking and defending software supply chains. Learn threats from dependency injection to artifact tampering and mitigation strategies.',
    topics: [
      'Supply Chain Threat Landscape',
      'Dependency Management Security',
      'Build Pipeline Exploitation',
      'Artifact Repository Security',
      'Code Signing & Verification',
      'DevSecOps Best Practices'
    ],
    suitableFor: [
      'DevSecOps engineers',
      'Security architects',
      'Software development leads',
      'Release management teams'
    ],
    benefits: [
      'End-to-end supply chain security knowledge',
      'Practical defense strategies',
      'Industry best practices',
      'Hands-on security tools',
      'Secure development methodology'
    ],
  },
  15: {
    summary: 'Take your web application pen-testing skills to the next level with this intermediate-level training course tailored for professional pen testers, bug hunters, and security enthusiasts. Rooted in the principles of the OWASP Testing Guide, this comprehensive course equips you with a structured and practical approach to uncovering vulnerabilities. By mapping workflows, understanding web application components, and utilizing open-source tools, you\'ll sharpen your ability to identify critical bugs with precision and efficiency. Designed for those actively engaged in pentest projects, this training is your key to becoming a more proficient and impactful web application pentester.',
    selfCheckQuestions: {
      mainQuestion: 'Do you catch yourself asking any of the following questions while pentesting web applications?',
      questions: [
        'I know how to run Burp Suite scans, but how do I find the unique bugs automated tools miss?',
        'Is my business logic testing actually thorough, or am I overlooking obvious flaws?',
        'How do I approach Blind XXE, advanced SQL injection, or chained XSS in a structured way?',
        'Am I confident my authentication and authorization testing is complete?',
        'How do I test beyond OWASP Top 10 and uncover vulnerabilities hidden in plain sight?',
        'Are my pentest reports detailed and actionable enough that clients trust the findings?'
      ]
    },
    topics: [
      'Introduction to Web App Testing',
      'Information Gathering',
      'Configuration and Deployment Management Testing',
      'Identity Management Testing',
      'Authentication Testing',
      'Authorization Testing',
      'Input Validation and Injection Testing',
      'Session Management Testing',
      'Testing for Components with Known Vulnerabilities',
      'Business Logic Testing',
      'Reporting'
    ],
    suitableFor: [
      'Senior Web Application Pentesters',
      'Junior Web Application Pentesters',
      'Security Engineers',
      'Bug Bounty Hunters',
      'Folks with 1-2 years experience in Web Pentesting'
    ],
    benefits: [
      'OVA file containing tools required for the lab.',
      'Access to State-of-the-Art Hacking Lab',
      'Comprehensive slide deck',
      'Answer sheets and cheat sheets',
      'Tips and tricks document for various attacks',
      '5 additional days of lab access post-training'
    ],
    requirements: [
      'Laptop with Admin Privileges',
      'Minimum 16 GB RAM',
      '100 GB Disk space for OVA',
      'Internet Access',
      'Ability to install Virtual Box'
    ],
    whatToExpect: [
      'Intensive hands-on labs with real vulnerable applications',
      'Structured curriculum following OWASP Testing Guide',
      'Group exercises and collaborative learning',
      'Real-world pentesting scenarios and case studies',
      'Daily assignments and practical challenges',
      'Interactive Q&A sessions with instructors'
    ],
    whatNotToExpect: [
      'Lecture-only format without hands-on practice',
      'One-on-one mentoring sessions',
      'Beginner-level fundamentals (this is intermediate)',
      'Certification exam preparation',
      'Extended support after training completion'
    ],
    whatYouWillReceive: [
      'OVA file with pre-configured lab environment and tools',
      'Comprehensive slide deck with all training materials',
      'Answer sheets and detailed cheat sheets',
      'Tips and tricks document for various attack scenarios',
      'Lab guides and practical exercise walkthroughs',
      '5 days of extended lab access post-training'
    ],
    trainingStructure: [
      {
        part: '1',
        title: 'Introduction to Web App Testing',
        topics: [
          'OWASP Top 10 Vulnerabilities',
          'OWASP Web App Testing Guide',
          'Introduction to Proxies',
          'Reporting as you go'
        ]
      },
      {
        part: '2',
        title: 'Information Gathering',
        topics: [
          'Search Engine discovery and reconnaissance for information leakage',
          'Fingerprinting the web server',
          'Enumerating applications on the web server',
          'Fingerprinting Application and Application Framework'
        ]
      },
      {
        part: '3',
        title: 'Configuration and Deployment Management Testing',
        topics: [
          'Application Platform Configuration',
          'Subdomain Takeover',
          'Cloud Storage'
        ]
      },
      {
        part: '4',
        title: 'Identity Management Testing',
        topics: [
          'Testing for Roles and Privileges',
          'Account Enumeration',
          'Login Brute Force',
          'Default Credentials',
          'Weak Username Policy'
        ]
      },
      {
        part: '5',
        title: 'Authentication Testing',
        topics: [
          'Testing Lockout Mechanisms',
          'Bypassing Authentication Schema',
          'JWT Attack',
          'Testing for Password Reset Functionalities',
          'Testing for Authentication in Alternative Channels',
          '2FA Bypass'
        ]
      },
      {
        part: '6',
        title: 'Authorization Testing',
        topics: [
          'Directory Traversal vulnerabilities',
          'Bypassing Authorization Schema',
          'Testing for Privilege Escalation',
          'Insecure Direct Object References (IDOR)'
        ]
      },
      {
        part: '7',
        title: 'Input Validation and Injection Testing',
        topics: [
          'SQL Injection vulnerabilities',
          'Time-Based SQL Injection',
          'Data Exfiltration via Blind OOB SQL Injection',
          'XML Injection vulnerabilities',
          'Vanilla XXE attack',
          'Data Exfiltration via Blind XXE attacks',
          'Modern XSS Attacks',
          'Host Header Injection',
          'SSRF Attacks',
          'SSRF on Traditional Web Apps',
          'SSRF over Cloud',
          'Template Injection Attacks',
          'Exploiting File Upload functionalities',
          'Deserialization Attacks'
        ]
      },
      {
        part: '8',
        title: 'Session Management Testing',
        topics: [
          'Testing Logout Functionality',
          'Testing for Session Hijacking',
          'Testing for Misconfigured Cookie Attributes',
          'Testing for Weak Cryptography',
          'Padding Oracle Attacks',
          'Exploiting Weak Encryptions'
        ]
      },
      {
        part: '9',
        title: 'Testing for Components with Known Vulnerabilities',
        topics: [
          'Attacking PHP Symphony',
          'Attacking vulnerable third-party libraries',
          'CMS Attacks',
          'Log4j'
        ]
      },
      {
        part: '10',
        title: 'Business Logic Testing',
        topics: [
          'Building models for Business logic Flows',
          'Attacking Coupon Functionality / Process Timing Attacks',
          'Attacking Payment Gateways',
          'Polluting Application Logs',
          'Circumventing Workflows'
        ]
      },
      {
        part: '11',
        title: 'Reporting',
        topics: [
          'Pitfals of Manual Reporitng',
          'Automated Reporting Tools',
          'Automation Tool Demo',
        ]
      }
    ]
  },
  18: {
    summary: 'One-day intensive hands-on training on practical threat hunting using three essential detection languages: Sigma (generic), Splunk/SPL, and KQL (Azure Sentinel/Defender). Master threat hunting methodologies, write detection rules, and analyze logs using pre-configured standalone VMs.',
    selfCheckQuestions: {
      mainQuestion: 'Do any of these questions keep you up at night as a blue teamer or SOC analyst?',
      questions: [
        'I respond to alerts all day : but how do I proactively hunt for attackers already inside?',
        'Everyone talks about Sigma rules : how do I actually write and deploy them effectively?',
        'My Splunk queries work, but are they really surfacing the right threat signals?',
        'How do I develop the hunter\'s mindset instead of just reacting to what the SIEM throws at me?',
        'How do threat hunters use KQL in Microsoft environments to detect advanced techniques?',
        'Am I missing attacker activity that\'s hiding in plain sight across my endpoints and logs?'
      ]
    },
    topics: [
      'Threat Hunting Mindset & Methodologies',
      'Sigma Rule Structure & Creation',
      'Splunk Architecture & SPL Queries',
      'KQL (Kusto Query Language) Basics',
      'PowerShell Abuse Detection',
      'WMI Abuse Detection',
      'Privilege Escalation Detection',
      'DLL Injection Detection',
      'LSASS Dump Detection',
      'Persistence Detection',
      'Defense Evasion Detection',
      'Credentials Access Detection',
      'Lateral Movement Detection',
      'Rule Conversion Across Platforms'
    ],
    requirements: [
      'Basic SIEM knowledge or exposure to logs',
      'Understanding of Windows event logs and endpoints',
      'Command-line familiarity (PowerShell/Bash)',
      'Laptop with 8GB RAM minimum',
      'Basic networking and threat concepts understanding'
    ],
    whatToExpect: [
      'Hands-on practical labs with pre-configured VMs',
      'Learn three query languages (Sigma, SPL, KQL) in one day',
      'Real threat hunting scenarios and exercises',
      'Practical detection rule writing for multiple platforms',
      'Log analysis and pattern recognition workshops',
      'Rule conversion demonstrations across different SIEM platforms',
      'Interactive labs covering 14 attack techniques'
    ],
    whatNotToExpect: [
      'Extended classroom labs spanning multiple days',
      'Multi-day certification path or exam preparation',
      'Advanced forensic analysis deep dives',
      'Custom SIEM deployment or configuration',
      'Post-training project work or mentoring'
    ],
    whatYouWillReceive: [
      'Pre-configured standalone VM with all necessary environments (Splunk, KQL sandbox)',
      'Handouts for all practical tasks and exercises covered',
      'References and resources for further study',
      'VM image access for continued self-practice after training',
      'Lab scenarios and threat hunting methodologies guide',
      'Sigma rule templates and conversion reference guides'
    ],
    trainingStructure: [
      {
        part: '1',
        title: 'The Hunter\'s Mindset',
        topics: [
          'Philosophy: "Assume Breach" vs. Alert Response',
          'Threat Hunting methodologies - Intelligence-based hunting',
          'Threat Hunting methodologies - Hypothesis-based hunting',
          'Investigation using indicators of attack (IoA)',
          'The Pyramid of Pain: Understanding why we hunt for TTPs',
          'The Hunting Process: Hypothesis → Data Investigation → Pattern Recognition → Detection Creation'
        ]
      },
      {
        part: '2',
        title: 'The Universal Language (Sigma)',
        topics: [
          'Concept: Sigma is "Signatures for Log Files" - Write once, convert to any SIEM',
          'Sigma Rule Structure (YAML)',
          'Sigma Modifiers',
          'Sigma Conditions',
          'Sigma Log Sources',
          'Practical Sigma Rules: PowerShell Abuse',
          'Practical Sigma Rules: WMI Abuse',
          'Practical Sigma Rules: Privilege Escalation',
          'Practical Sigma Rules: DLL Injection',
          'Practical Sigma Rules: LSASS Dump',
          'Practical Sigma Rules: Persistence Detection',
          'Practical Sigma Rules: Defence evasion',
          'Practical Sigma Rules: Credentials access',
          'Practical Sigma Rules: Lateral Movement & Discovery'
        ]
      },
      {
        part: '3',
        title: 'Splunk & SPL (Local Setup)',
        topics: [
          'Architecture and Basics: Forwarders, Indexer, Search Head',
          'Search Processing Language (SPL): Search',
          'Search Processing Language (SPL): Filter',
          'Search Processing Language (SPL): Time Modifiers',
          'Search Processing Language (SPL): Subsearch',
          'Search Processing Language (SPL): Common Stats Functions',
          'Conversion of Sigma rules to Splunk SPL Rules (Practical)',
          'Lab Prep: Installing/Configuring Splunk on local VM',
          'Lab Prep: Ingest data to Splunk',
          'Lab Prep: SPL queries for Threat Hunting'
        ]
      },
      {
        part: '4',
        title: 'KQL (Kusto Query Language)',
        topics: [
          'KQL Basics and Context: Microsoft Sentinel, Defender for Endpoint, Azure Monitor',
          'KQL Syntax: Search',
          'KQL Syntax: Filters',
          'KQL Syntax: Stats',
          'KQL Syntax: Let Statements',
          'KQL Syntax: Set Statements',
          'Hands-On KQL: Setup the ADX Web Explorer (Practical Lab)',
          'Hands-On KQL: Ingest data (Practical Lab)',
          'Hands-On KQL: Create KQL Queries for Threat Hunting (Practical Lab)'
        ]
      }
    ],
    suitableFor: [
      'Graduation or Post Graduation Students',
      'SOC Analysts',
      'Security Analysts',
      'Threat Intelligence Researchers',
      'Malware Analysts',
      'Threat Hunters',
      'Detection Engineers',
      'Digital Forensic Investigators',
      'Incident Response Analysts',
      'SIEM Engineers/Analysts',
      'Security Engineers'
    ],
    benefits: [
      'Pre-configured standalone VM with all necessary environments',
      'Learn three essential detection query languages in one day',
      'Hands-on practical labs with real threat scenarios',
      'Sigma rule creation covering multiple attack techniques',
      'SPL query development for Splunk environments',
      'KQL training for Microsoft Sentinel and Azure Defender',
      'Rule conversion techniques across different SIEM platforms',
      'Access to VM image for continued self-practice after training',
      'Handouts for all practical tasks covered in training',
      'References for further study of threat hunting concepts'
    ],
  },
  17: {
    summary: 'In 2026, one lesson is clear: software supply chain attacks are some of the hardest threats to understand and some of the easiest for attackers to exploit. Threat actors are not just attacking the perimeter. They are going after developers, automation, and the software delivery lifecycle itself. From Shai Hulud and npm worms to poisoned packages, malicious IDE plugins, and build hijacks, recent attacks have proven that a single compromised dependency can move through trusted pipelines straight into production. Developer laptops, source repos, CI runners, containers, and clusters now operate as one ecosystem, where everything is a connected attack surface.',
    selfCheckQuestions: {
      mainQuestion: 'Do any of these questions come up when you\'re shipping or reviewing software pipelines?',
      questions: [
        'How do real-world supply chain attacks like SolarWinds or XZ Utils actually work end-to-end?',
        'Am I confident the open-source packages in our codebase haven\'t been tampered with?',
        'Could an attacker inject malicious code into our CI/CD pipeline without us noticing?',
        'What does a practical, implementable defense strategy for supply chains actually look like?',
        'How do frameworks like SLSA or NIST SSDF apply to the systems I actually work on?',
        'I know supply chain security matters : but where do I even start?'
      ]
    },
    topics: [
      'Software Supply Chain Architecture & Threat Landscape',
      'Developer Environment & IDE Security',
      'Git & GitHub Misconfigurations',
      'Dependency & Package Management Security',
      'CI/CD Pipeline Exploitation & Defense',
      'Container Image Security',
      'Kubernetes & Cloud Attack Paths',
      'IAM & Cloud Configuration Security',
      'Supply Chain Provenance & Verification',
      'SLSA Framework Implementation',
      'NIST SSDF Standards',
      'Software Bill of Materials (SBOM)',
      'Runtime Security & Threat Detection',
      'Incident Response & Recovery'
    ],
    requirements: [
      'Basic CI/CD pipeline knowledge',
      'Git and GitHub fundamentals',
      'Linux command line proficiency',
      'Understanding of containerization (Docker basics)',
      'Basic IAM and cloud concepts',
      'Laptop with 8GB RAM minimum'
    ],
    whatToExpect: [
      'Both attacker and defender perspectives on supply chain security',
      'Hands-on labs simulating real supply chain attacks',
      'Practical demonstrations of exploitation techniques',
      'Implementation labs for SLSA and NIST SSDF frameworks',
      'CI/CD pipeline security deep dives',
      'Cloud and Kubernetes attack path analysis',
      'Real-world incident case studies and analysis'
    ],
    whatNotToExpect: [
      'Theory-only lectures without practical labs',
      'Developer-only focus (DevOps perspectives included)',
      'Beginner-level content',
      'Exhaustive training on each tool (focused on concepts)',
      'Extended project work after training'
    ],
    whatYouWillReceive: [
      'VMs to take home for continued learning and practice',
      'Detailed step-by-step instruction manuals for all labs',
      'Complete documentation of training content and exercises',
      'Vulnerable environments for hands-on exploitation',
      'Real-world case study materials and attack replications',
      'Reference materials for SLSA and NIST SSDF frameworks'
    ],
    trainingStructure: [
      {
        part: '1',
        title: 'From the Attacker\'s Perspective – Understanding Software Supply Chain Attacks',
        topics: [
          'Introduction to Software Supply Chain',
          'Supply chain beyond code dependencies',
          'Exploiting VS Code Workspaces',
          'Trojanizing IDE & Browser Extensions',
          'Exploiting Git & GitHub Misconfigurations',
          'Attacking CI Pipelines & custom runners',
          'Creating malicious dependencies',
          'Attacking package management ecosystems (npm, gradle, etc.)',
          'Exploiting Deployment Systems (GitHub & ArgoCD)',
          'Leveraging container image misconfigurations',
          'Looking at Cloud & Kubernetes attack paths',
          'Attacking Cloud Environment (IAM, Data, Configurations)',
          'Exploiting Kubernetes Misconfigurations & Insecure Defaults'
        ]
      },
      {
        part: '2',
        title: 'From Vulnerability to Fortification – Securing Your Software Supply Chain',
        topics: [
          'Introduction to Defense Strategies: SLSA and NIST SSDF',
          '360° Security strategies & Top-down Defense from Governance',
          'Effective Inventory Management & SBOMs',
          'Establishing, storing & verifying Provenance',
          'Protecting The Assets & Establishing Baseline Security',
          'Cloud Audits',
          'Runtime Security',
          'Threat detection',
          'Responding and Recovering from the Security Breaches',
          'Mapping Different Roles and Responsibilities',
          'Securing yourself from the discussed attacks'
        ]
      }
    ],
    suitableFor: [
      'Software Developers and Engineers',
      'IT Managers',
      'Security Analysts',
      'DevOps Practitioners',
      'CTOs and Decision Makers in IT',
      'Pentesters',
      'Red Teamers'
    ],
    benefits: [
      'Comprehensive understanding of software supply chain vulnerabilities and defenses',
      'Expert guidance on implementing security measures across different components',
      'Knowledge of industry-standard security frameworks (SLSA and NIST SSDF)',
      'Detailed step-by-step instruction manual for all challenges covered',
      'VM\'s to take home for practice and self-learning',
      'Documentation of all content covered during the class',
      'Hands-on labs with vulnerable environments',
      'Real-world case studies and attack replications'
    ],
  },
  16: {
    summary: 'Cutting-edge 100% hands-on training on attacking AI systems, models, and native applications. Master prompt injection, supply chain exploitation, model poisoning, MCP protocol attacks, and multi-agent system compromise through real-world exercises.',
    selfCheckQuestions: {
      mainQuestion: 'Do you find yourself wondering any of the following as AI gets embedded in every product you test?',
      questions: [
        'How do I actually attack an LLM-powered application : where do I even start?',
        'What does an AI supply chain attack look like in practice?',
        'How are AI agents different from traditional apps when it comes to security testing?',
        'What is MCP and why should I care about it from an offensive perspective?',
        'How do I test for prompt injection or model poisoning in a structured way?',
        'IDEs and browsers now have AI built-in : how do I assess their attack surface?'
      ]
    },
    topics: [
      'AI Fundamentals & Model Architectures',
      'Deploying and Experimenting with Open-Source LLMs',
      'OWASP GenAI Top 10',
      'Prompt Injection & Jailbreak Techniques',
      'System Prompt Leakage & Exploitation',
      'AI Supply Chain Attacks & Vulnerable Dependencies',
      'Data & Model Poisoning Attacks',
      'Backdooring ML Models',
      'Model Context Protocol (MCP) Security',
      'Breaking MCP Trust Model',
      'Multi-Agent System Exploitation',
      'Attacking AI-Native Browsers & IDEs',
      'Token Leakage & OAuth Attacks',
      'Real-World Case Studies & Incident Analysis'
    ],
    requirements: [
      'Basic Python programming knowledge',
      'Understanding of REST APIs and HTTP requests',
      'Familiarity with LLMs (ChatGPT, Claude, Llama, etc.)',
      'Linux/Windows command line basics',
      'OpenRouter Account Setup: An active OpenRouter account with a minimum of $25 in credits is required to complete the hands-on labs in this training. Please set this up before the training begins. since locally running would be difficult.',
      'Laptop with minimum 8GB RAM (16GB recommended)',
      'Understanding of AI/ML concepts (beneficial)'
    ],
    whatToExpect: [
      'Real-world AI security exploits and demonstrations',
      'Hands-on labs attacking vulnerable AI systems',
      'VM-based practical exercises with pre-configured environments',
      'Multi-agent system attack scenarios',
      'Deep dives into prompt injection and jailbreak techniques',
      'Case studies of real AI security breaches',
      'Interactive labs breaking MCP protocol trust model'
    ],
    whatNotToExpect: [
      'Defensive-only content (this is offensive focused)',
      'AI deployment and ops training',
      'Beginner AI and ML theory',
      'Model training or fine-tuning exercises',
      'Cloud AI service deployments (AWS/Azure)'
    ],
    whatYouWillReceive: [
      'Pre-configured lab VMs with all necessary tools and models',
      'Complete training slide deck and reference materials',
      'Lab source code and exploit demonstrations',
      'Access to private Slack channel for ongoing support and networking',
      'VM image to take home for continued self-practice',
      'Certificate of completion',
      'References for further learning and research'
    ],
    trainingStructure: [
      {
        part: '0',
        title: 'AI Hacking Crash Course',
        topics: [
          'Modern AI and Model Architectures',
          'Deploying and experimenting with open-source LLMs on local environments',
          'Exploring Ollama internals: manifest, prompt templates, and tokenization layers',
          'Practical Lab: Manipulating local model behaviors',
          'Understanding function execution, external tool integrations, and Retrieval-Augmented Generation (RAG)',
          'OWASP GenAI Top 10'
        ]
      },
      {
        part: '1',
        title: 'AI Red teaming',
        topics: [
          'Introduction to Prompt Injection & Jailbreak',
          'System prompt leak on multimodal agents (lab)',
          'Prompt Injection cheatsheet, COT Injection',
          'Invisible prompt injection',
          'Red Teaming local AI models: Categorizing and evaluating jailbreaks (lab)',
          'Grammar-based fuzzing & detection',
          'Case Study: Exposing hidden system and assistant prompts from leading LLMs (ChatGPT, Llama, Grok, Gemini)',
          'Case Study: Abusing of code-assistant outputs: a copilot prompt-injection PoC enabling RCE'
        ]
      },
      {
        part: '3',
        title: 'Attacking AI Supply Chain',
        topics: [
          'Introduction to software supply chain in relevance in AI systems',
          'AI-BOM, ML-BOM tools to detect unsafe dependencies',
          'AI development framework vulnerabilities',
          'Case study: Shai-Hulud npm attack campaign',
          'Case Study: Analyzing and exploiting CVE-2025-XXXXX (lab)',
          'Case Study: Analyzing and exploiting CVE-2025-XXXXX (lab)',
          'Case Study: Analyzing and exploiting CVE-2025-XXXX (lab)',
          'Case Study: Attacking opensource model loading and chaining exploits (e.g., CVE-2025-3XXXX)'
        ]
      },
      {
        part: '4',
        title: 'Data & Model Poisoning, Extraction and Theft',
        topics: [
          'Introduction to Vectors and Embeddings and RAG Spray attack (lab)',
          'Backdooring Models (lab)',
          'Adversarial attacks (lab)',
          'Case Study: Silently Backdoored Hugging Face ML Models',
          'Case Study: Invisible prompt injection techniques against Google Jules'
        ]
      },
      {
        part: '5',
        title: 'Introduction to Model Context Protocol (MCP)',
        topics: [
          'Introduction to Model Context Protocol',
          'Single and multi agent MCP architecture',
          'Need for MCP Registry and implementation flaws',
          'Sniffing and decoding MCP communications over STDIO & SSE',
          'Breaking the MCP Trust Model (lab): Rug pull',
          'Breaking the MCP Trust Model (lab): Sampling attack',
          'Case Study: Anthropic MCP vulnerabilities, from path traversal to privilege escalation'
        ]
      },
      {
        part: '6',
        title: 'Attacking Agentic Systems',
        topics: [
          'Introduction to Multi Agent systems',
          'Multi-level prompt injection: cross-model injections (lab)',
          'Attacking the MCP Registry (lab)',
          'Token Passthrough',
          'Session Hijacking',
          'Tool poisoning',
          'Confused Deputy Problem',
          'OAuth & Identity Attacks',
          'Unauthenticated/unauthorized registry modification',
          'Shadow Tools',
          'Privilege escalation, SSRF and exploiting improper output handling on Multi Agentic Systems (lab)'
        ]
      },
      {
        part: '7',
        title: 'Attacking AI Apps (Next gen Browsers & IDE)',
        topics: [
          'Introduction to AI native apps',
          'Case Study: Attacking AI-native browsers (Edge, Perplexity Comet, OpenAI Atlas etc)',
          'Case Study: RCE on WindSurf through DNS Rebinding and malicious GRPC packets (lab)',
          'Case Study: Data Exfiltration in Cursor CVE-2025-5XXXX',
          'Case Study: Data Exfiltration in Claude Code with DNS (CVE-2025-XXXXX)'
        ]
      }
    ],
    suitableFor: [
      'AI Security Enthusiasts & Beginners',
      'Security Professionals & Red Teamers',
      'Penetration Testers & Bug Bounty Hunters',
      'Security Researchers',
      'Developers & AI Engineers'
    ],
    benefits: [
      'Lab Virtual Machines with pre-installed tools and datasets',
      'Digital copies of all training slides and lab materials',
      'Source Code Access for custom applications built for training',
      'Access to private Slack channel for ongoing support and networking',
      'Certificate of completion',
      'Hands-on experience exploiting real AI vulnerabilities',
      'Network with security professionals and instructors',
      'Practical knowledge of prompt injection and supply chain attacks'
    ],
  },
  19: {
    summary: 'Master red teaming techniques targeting Active Directory and Azure Entra ID in hybrid environments. Learn to exploit misconfigurations, perform lateral movement between on-premise and cloud, achieve persistence, and execute full-spectrum adversary simulation. Includes hybrid lab access from Day 1.',
    selfCheckQuestions: {
      mainQuestion: 'Do you catch yourself asking any of the following during red team engagements or AD assessments?',
      questions: [
        'I can run BloodHound, but how do I truly understand and chain AD attack paths?',
        'Clients are moving to Entra ID : how do I assess hybrid identity environments?',
        'How do I perform lateral movement between on-prem AD and Azure without getting caught?',
        'What does a real-world AD compromise look like end-to-end, from initial foothold to Domain Admin?',
        'How are red team tactics different when the environment is cloud-joined vs. fully on-prem?',
        'Am I missing misconfigurations that defenders would catch but I keep overlooking in assessments?'
      ]
    },
    topics: [
      'Enterprise AD Infrastructure & Security Model',
      'Unauthenticated & Authenticated AD Enumeration',
      'Active Directory Exploitation (LDAP, SMB, RPC, SPN, ACL, GPO)',
      'Kerberos Abuse & Custom Evasion Toolkits',
      'Privilege Escalation & Lateral Movement',
      'Entra ID Fundamentals & Attack Surface',
      'Entra ID Exploitation & Privilege Escalation',
      'On-Premise to Cloud Lateral Movement',
      'Cloud to On-Premise Access via Entra ID Connect & Intune',
      'Cross-Tenant Access & Azure ARC Exploitation',
      'Red Team Case Studies & Full Kill Chain',
      'Blue Team Detection & Investigation'
    ],
    requirements: [
      'At least 2-3 years of penetration testing experience',
      'Comfortable with command line environment',
      'Able to install virtual software and configure routing between VMs',
      'Fair knowledge of Penetration Testing Methodology',
      'Basic understanding of cloud concepts (VMs, Storage, Users)',
      'System with minimum 16GB RAM with VMware Workstation PRO',
      'Attacker Linux VM (Kali) with internet connectivity'
    ],
    whatToExpect: [
      'Technical deep dive into stealthy attack vectors against both Active Directory and Entra ID',
      'Hands-on practice lab of entire red team cycle from reconnaissance to silent execution',
      'Advanced techniques for on-premise to cloud and vice-versa movement',
      'Real enterprise attack scenarios and case studies',
      'Hybrid lab environment with full Active Directory and Entra ID setup',
      'Custom tooling for evading AD monitoring solutions',
      'Open discussion on red team ideas and attack path optimization'
    ],
    whatNotToExpect: [
      'N-Day or 0-Day exploits for commercial/open source software',
      'Simple point-and-click vulnerability scanning or automated tools',
      'Theoretical content (85% of training is practical hands-on)',
      'Beginner-level fundamentals'
    ],
    whatYouWillReceive: [
      'Entire course material (PDF) including commands and slides',
      'Enterprise hybrid lab environment and walkthrough',
      'Custom and internal scripts for AD & Entra ID exploitation',
      'Hybrid lab access from Day 1 of training',
      'Comprehensive attack methodology documentation',
      'Post-training reference materials and tool resources'
    ],
    suitableFor: [
      'Penetration Testers and Red Teams',
      'Security Architects, Engineers & Consultants',
      'Blue Team Analysts, Engineers & Consultants',
      'Purple Team Members',
      'Anyone strengthening AD & Entra ID security skills'
    ],
    benefits: [
      'Master hybrid environment red teaming',
      'Advanced Active Directory and Azure Entra ID exploitation',
      'Stealthy TTPs and evasion techniques',
      'Full kill chain adversary simulation capabilities',
      'Real enterprise attack methodology',
      'Hands-on hybrid lab from Day 1',
      'Expert instruction from CyberWarFare Labs founders',
      'Maximum capacity: 80 students for hands-on learning'
    ],
    trainingStructure: [
      {
        part: '1',
        title: 'Red Teaming in Active Directory Environment',
        topics: [
          'Enterprise AD Infrastructure',
          'Unauthenticated Recon (LDAP, DNS, SMB, RPC, AD Objects, GPO, SPNs, ACLs)',
          'Identify privileged servers and workstations',
          'Initial Foothold: Password Spraying, ASREP Roasting',
          'Authenticated Enumeration & Domain Dominance',
          'Lateral Movement Path Identification',
          'Privilege Escalation: Kerberos Abuse, ACL Abuse',
          'Custom Toolkits for evading AD monitoring',
          'Code execution on privileged servers',
          'Credential dumping techniques'
        ]
      },
      {
        part: '2',
        title: 'Red Teaming in Entra ID (Azure AD)',
        topics: [
          'Azure Cloud Fundamentals',
          'Entra ID, ARM, and M365 Architecture',
          'Administrator Roles & RBAC',
          'Microsoft Graph and Management API',
          'Unauthenticated & Authenticated Enumeration',
          'Initial Access: Password Spray, Web App Exploitation, Consent Grant Attack',
          'Persistence: App Registration, Automation Account',
          'Privilege Escalation: App Permissions, RBAC',
          'Credential Access & Data Exfiltration: IMDS, Key Vault Secrets'
        ]
      },
      {
        part: '3',
        title: 'Lateral Movement from On-Premise to Cloud and Vice Versa',
        topics: [
          'On-Premise to Azure Cloud: PRT Abuse, Entra ID Connect Exploitation, Golden Ticket via Seamless SSO',
          'Azure Cloud to On-Premise: Microsoft Intune Code Execution, Azure ARC Exploitation',
          'Azure Cloud to Azure Cloud: Cross Tenant Access',
          'Hybrid environment attack chain execution',
          'Persistence across hybrid boundaries'
        ]
      },
      {
        part: '4',
        title: 'Red and Blue Team Case Study',
        topics: [
          'Red Team Ops in Enterprise AD & Azure AD Environment [Full Kill Chain]',
          'Detection & Investigation of AD Attacks',
          'Detection & Investigation of Azure AD Attacks',
          'Evasion techniques vs detection mechanisms',
          'Real-world incident analysis'
        ]
      }
    ]
  },
  20: {
    summary: 'Modern cloud attacks rarely rely on obscure tricks. Most compromises come from exposed services, weak trust boundaries, over-privileged identities, insecure workload design, metadata access, and poor separation between application and cloud control layers. This hands-on course teaches students to identify and exploit these patterns in AWS and Google Cloud through realistic labs. Focusing only on AWS and GCP, the training emphasizes depth over breadth. Students deploy vulnerable environments with Terraform and work through attack chains involving storage exposure, SSRF, IAM abuse, secret extraction, GKE footholds, and service account misuse, with structured debriefs on prevention, detection, and containment.',
    selfCheckQuestions: {
      mainQuestion: 'Do any of these questions come up when you\'re assessing or securing cloud environments?',
      questions: [
        'I know AWS and GCP basics, but how do I find and exploit real misconfigurations like attackers do?',
        'What do IAM privilege escalation attacks actually look like in a live AWS environment?',
        'How do attackers move laterally inside a cloud account once they have an initial foothold?',
        'What techniques were used in public cloud breaches, and could my environment be vulnerable too?',
        'How do I exfiltrate data from cloud storage without triggering obvious alerts?',
        'Am I building my cloud defenses around what actually gets exploited, or just checking compliance boxes?'
      ]
    },
    topics: [
      'AWS IAM & Bucket Misconfigurations',
      'Google Cloud Security Issues',
      'API Exploitation',
      'Network Exploitation',
      'Data Exfiltration Techniques',
      'Lateral Movement in Cloud',
      'Defense Strategies & Mitigation'
    ],
    requirements: [
      'Modern version of Windows, macOS, or Linux',
      'Stable internet connection and updated browser (Chrome or Firefox)',
      'Activated AWS and Google Cloud accounts (verified and tested)',
      'Basic familiarity with Linux command line tools: grep, cut, dig, curl, ssh, text editor',
      'Familiarity with common web security issues: SSRF, XSS, SQL injection',
      'General cloud concepts understanding',
      'Basic understanding of IAM, Terraform, and Kubernetes (course will guide as needed)',
      'Tested basic functionality by starting and stopping compute resources in each cloud provider'
    ],
    whatToExpect: [
      'Hands-on labs with real cloud infrastructure',
      'Real-world attack scenarios from public breaches',
      'Comprehensive documentation and takeaways',
      'Lab environment setup and configuration practice',
      'Defense brainstorming and mitigation strategies',
      'Cloud attack methodology and MITRE ATT&CK framework applications',
      'Reconnaissance and foothold discovery techniques',
      'AWS serverless and data access attack paths',
      'GCP Cloud Run and Kubernetes Engine security testing',
      'Capstone-style exercises with full kill chains'
    ],
    whatNotToExpect: [
      'Lecture-only format without hands-on practice',
      'Beginner-level cloud fundamentals',
      'Coverage of all cloud providers (AWS and GCP only)',
      'Passive reconnaissance tools only'
    ],
    whatYouWillReceive: [
      'Live documentation portal during class with exercise details, setup steps, attack walkthroughs, and reference material',
      'Detailed step by step written instructions for all challenges covered in the course',
      'Post-class access to Terraform scripts and supporting lab material to redeploy and practice scenarios independently',
      'Working labs and reusable attack workflows for continued practice',
      'Environment deployment material for setting up vulnerable cloud infrastructure',
      'Comprehensive written guidance to continue learning after the training is over'
    ],
    suitableFor: [
      'Security Engineers',
      'Penetration Testers',
      'Cloud Security Professionals',
      'DevSecOps Engineers',
      'Cloud Architects'
    ],
    benefits: [
      'Identify and exploit cloud misconfigurations',
      'Real-world attack methodology and frameworks',
      'Comprehensive defense strategies',
      'Hands-on lab access with real AWS and GCP infrastructure',
      'Industry expert mentorship',
      'Practical cloud security knowledge',
      'Reusable attack workflows and tooling',
      'Post-training resources for continued learning'
    ],
    trainingStructure: [
      {
        part: '1',
        title: 'Day 1: Foundations, setup, discovery, and foothold',
        description: 'The first day establishes the working model for the rest of the class. Students will validate AWS and GCP access, deploy the base lab infrastructure, set up their attacker environment, and build familiarity with the tools and workflows used during the training.\n\nThe day then moves into cloud attack methodology and introduces how attackers think about exposed services, identities, APIs, workloads, and trust boundaries. MITRE ATT&CK for cloud is used as a framing layer so students can map techniques to broader attacker behavior.\n\nThe main hands-on work for the day focuses on reconnaissance and foothold discovery. Students will identify exposed AWS and GCP assets using OSINT techniques, cloud specific service discovery patterns, storage enumeration, and target profiling. This includes bucket and object exposure analysis, identifying exposed cloud services, and understanding how public exposure becomes the entry point for broader compromise.'
      },
      {
        part: '2',
        title: 'Day 2: AWS attack paths',
        description: 'The second day is dedicated to AWS. Students begin with a scenario that chains application weakness into cloud access by abusing SSRF and reaching the instance metadata service. From there they extract temporary credentials, enumerate permissions, and understand how AWS IAM design impacts blast radius.\n\nThe next major block focuses on serverless and data access scenarios. Students will attack a vulnerable Lambda based workflow, leak credentials or tokens, identify reachable resources, and work through an RDS connected path to access or reconstruct sensitive data. The goal is to show how seemingly small mistakes in application and cloud integration can expose valuable assets.\n\nThe day ends with a consolidation block where students repeat core attack paths with lighter guidance and then review defensive controls for IAM, metadata protections, serverless security, database access, and logging.'
      },
      {
        part: '3',
        title: 'Day 3: GCP attack paths',
        description: 'The third day shifts to Google Cloud. Students begin with a Cloud Run scenario where a web application weakness is abused to gain access to a managed cloud workload and extract secrets from Secret Manager. This section focuses on how application level issues become cloud platform issues when service accounts and secret access are poorly scoped.\n\nThe second major block covers GKE. Students gain footholds inside a Kubernetes environment, extract secrets, abuse service account permissions, and move from workload compromise toward wider platform access. The emphasis is on understanding how cluster misconfigurations, workload identity mistakes, and poor internal trust separation enable escalation.\n\nThe class closes with a capstone style exercise, final debriefs, defensive takeaways for both AWS and GCP, and teardown guidance so students can safely remove infrastructure and continue practicing after the course.'
      }
    ]
  },
  21: {
    summary: 'This three-day hands-on training equips cybersecurity professionals with skills to collect, analyze, automate, and operationalize Cyber Threat Intelligence (CTI). Progress from foundational concepts to advanced threat hunting and intelligence integration, ensuring deep understanding of CTI frameworks, adversary tactics, OSINT techniques, automation, and various intelligence sources like malware and darknet.',
    selfCheckQuestions: {
      mainQuestion: 'Do you find yourself asking any of these questions in your security role?',
      questions: [
        'How do I collect and analyze threat intelligence effectively from multiple sources?',
        'Can I automate threat intelligence collection and enrich threat feeds with Python?',
        'How do I extract intelligence from malware samples and darknet sources?',
        'What\'s the best way to implement threat hunting in my organization?',
        'How do I operationalize CTI and integrate it into my SOC or security workflows?',
        'How can I build a scalable threat intelligence program from the ground up?'
      ]
    },
    topics: [
      'Cyber Threat Intelligence Fundamentals',
      'OSINT Collection & Analysis',
      'Threat Intelligence Automation with Python',
      'Malware & Darknet Intelligence',
      'Threat Hunting Basics',
      'CTI Operationalization',
      'Building CTI Programs',
    ],
    suitableFor: [
      'Security Analysts & SOC Teams',
      'Threat Intelligence Analysts',
      'Incident Responders',
      'Threat Hunters',
      'Security Professionals implementing CTI',
    ],
    benefits: [
      'Deep understanding of CTI frameworks and intelligence lifecycle',
      'Hands-on automation experience with Python',
      'Practical threat hunting and malware analysis skills',
      'Real-world threat datasets and case studies',
      'Knowledge of operationalizing CTI in organizations',
      'MITRE ATT&CK framework integration experience',
    ],
    requirements: [
      'Basic understanding of cybersecurity concepts (threat actors, threat hunting, malware, IOCs, TTPs)',
      'Familiarity with Python scripting (loops, conditionals, file handling)',
      'Basic knowledge of network security (IP addresses, ports, logs, firewalls)',
      'Familiarity with the Linux command line',
      'Personal laptop (Windows, macOS, or Linux)',
      'Minimum 8GB RAM and 50GB available disk space',
      'Pre-installed hypervisor (VMware Workstation/Player or VirtualBox)',
      'Python 3.x and Jupyter Notebook installed and verified',
      'Full administrative/root privileges on your device',
      'Device free of corporate Endpoint Management (MDM) or restrictive Group Policies'
    ],
    whatToExpect: [
      'Fundamentals of Cyber Threat Intelligence (CTI)',
      'Intensive, hands-on training with real-world threat datasets in every module',
      'Hands-on automation exercises designed to put concepts into practice',
      'Insights into building and operationalizing CTI capabilities from scratch',
      'Fundamentals of extracting intelligence from malware samples and threat hunting',
      'Practical skills to enhance organization\'s security posture and automate intelligence gathering'
    ],
    whatNotToExpect: [
      'Theoretical lecture series - this is hands-on training',
      'Beginner programming course - basic Python knowledge is highly recommended',
      'Focus on offensive security or penetration testing',
      'In-depth reverse engineering coverage - only basic malware analysis'
    ],
    whatYouWillReceive: [
      'Comprehensive slide decks covering all training content',
      'Jupyter Notebook with practical exercises and labs',
      'Real-world threat datasets for hands-on practice',
      'Lab environment setup guides and resources',
      'References and resources for continued learning after training',
      'Certificate of completion'
    ],
    trainingStructure: [
      {
        part: '1',
        title: 'Module 1: Fundamentals of Threat Intelligence',
        topics: [
          'What is Cyber Threat Intelligence (CTI)?',
          'The intelligence lifecycle',
          'Strategic, operational, tactical, and technical intelligence',
          'Cyber Kill Chain, MITRE ATT&CK Framework, and Diamond Model',
          'Types of threat actors and their motivations',
          'How CTI supports various Cybersecurity functions',
          'Case studies on real-world cyber threats',
        ]
      },
      {
        part: '2',
        title: 'Module 2: Python Refresher',
        topics: [
          'Data Types',
          'Conditionals & Loops',
          'Functions',
          'File Handling',
          'Virtual Environment, Modules & Package',
          'Parsing and Structuring Data (JSON, XML, CSV, STIX/TAXII)',
        ]
      },
      {
        part: '3',
        title: 'Module 3: OSINT for Threat Intelligence',
        topics: [
          'Introduction to Open-Source Intelligence (OSINT)',
          'Tools and techniques for gathering OSINT data',
          'Understanding indicators of compromise (IOCs)',
          'Hands-on: Analyzing OSINT Reporting',
          'Extracting intelligence from social media, domain records, and breach data',
          'Using threat intelligence feeds (STIX/TAXII, VirusTotal, etc.)',
          'Hands-on: Using OSINT to Pivot & Correlate',
        ]
      },
      {
        part: '4',
        title: 'Module 4: Threat Intelligence Automation',
        topics: [
          'Hands-on: Automating OSINT collection with Python',
          'Parsing threat feeds with Python',
          'Data enrichment and correlation',
          'Hands-on: Writing scripts to collect, process, and analyze threat data',
          'Introduction to MISP',
          'Alerting & Notification Automation',
          'Hands-on: Setting up TAXII feeds for intelligence sharing',
          'Honeypots for CTI Collection',
        ]
      },
      {
        part: '5',
        title: 'Module 5: Adversary and Malware Analysis',
        topics: [
          'Gathering malware intelligence from public sources',
          'Static and dynamic malware analysis basics',
          'File Classification and Working with Hashes',
          'Extracting and Analyzing Data from Binary File Formats',
          'Hands-on: Extracting IOCs from malware samples',
          'Darknet Sources & Threat Actors (Cybercrime Enablers)',
          'Operational Security (OPSEC)',
          'Hands-on: Adversary Analysis from Leaked Chats',
        ]
      },
      {
        part: '6',
        title: 'Module 6: Threat Hunting Basics',
        topics: [
          'Introduction to threat hunting',
          'Using TI for proactive defense',
          'Analyzing & Parsing PCAPs',
          'Integrating & Contextualizing Internal Threat Data/Logs with External Sources',
          'Hands-on: YARA rules for malware detection',
          'Hands-on: Using Sigma rules for threat detection',
          'Using CTI for Proactive Threat Hunting',
        ]
      },
      {
        part: '7',
        title: 'Module 7: Operationalize CTI',
        topics: [
          'Intelligence Requirement Gathering',
          'Tracking Emerging Threats',
          'Hands-on: Keeping up with the Emerging Threats',
          'Hands-on: Mapping TTPs to MITRE ATT&CK Framework',
          'Showcase Your Findings',
          'Scaling Operations',
        ]
      },
      {
        part: '8',
        title: 'Module 8: Building a CTI Program',
        topics: [
          'Threat intelligence in SIEMs, EDRs, and SOC workflows',
          'Understanding Business Needs',
          'Stakeholders Engagement',
          'Intelligence Sharing & Collaboration',
          'Key metrics for evaluating CTI programs',
          'Hands-on: Building a strategy for your organization',
        ]
      }
    ]
  },
  22: {
    summary: 'Executive-focused one-day training for CISOs and security leaders to understand AI-native threat landscapes, secure agentic systems, and enable safe AI adoption. Learn practical approaches to threat modeling, framework application (OWASP, SAIF, CoSAI, AARM), runtime security controls, and governance strategies for autonomous AI systems.',
    selfCheckQuestions: {
      mainQuestion: 'As a security leader, do you find yourself asking any of these questions about AI adoption?',
      questions: [
        'How do agentic systems introduce new attack surfaces that traditional controls can\'t address?',
        'What does runtime enforcement actually look like for autonomous AI systems?',
        'How do I evaluate AI use cases from both security and risk perspectives?',
        'What frameworks (OWASP, SAIF, AARM, CoSAI) actually apply to my organization?',
        'How can we enable AI adoption without becoming the bottleneck?',
        'What\'s the difference between securing AI systems and governing AI behavior?'
      ]
    },
    topics: [
      'AI Security Reality Check for Security Leaders',
      'AI Threat Landscape & Attack Patterns',
      'AI in Security Operations (SecOps)',
      'Agentic Architecture & RAG/MCP Risks',
      'Security Frameworks Landscape (OWASP, SAIF, CoSAI, AARM)',
      'AARM: Runtime Security for AI Actions',
      'AI Security Evals: Quality + Security',
      'Prevention, Detection & Response for AI Systems',
      'Governance, Adoption & Vendor Evaluation',
      'AI Security Operating Model'
    ],
    suitableFor: [
      'CISOs and Deputy CISOs',
      'Security Engineering Leaders',
      'SOC and IR Leaders',
      'Enterprise Security Architects',
      'Security leaders responsible for AI adoption and governance'
    ],
    benefits: [
      'Practical mental model for AI-native risk understanding',
      'Decision framework for securing AI adoption across enterprise',
      'Deep understanding of agentic system attack surfaces',
      'Knowledge of runtime enforcement for autonomous systems',
      'Framework evaluation and implementation guidance',
      'Strategies to enable AI without becoming the bottleneck',
      'Prevention, detection, and response playbooks for AI systems'
    ],
    requirements: [
      'Current role in security leadership or governance',
      'Basic understanding of AI/LLM concepts',
      'Experience with security frameworks and risk management',
      'Interest in enterprise AI governance'
    ],
    whatToExpect: [
      'Executive-friendly, discussion-driven format',
      'Real-world attack scenarios and enterprise workflows',
      'Lightweight SecOps AI agent demonstration',
      'Framework landscape overview and practical application',
      'Strategic and tactical guidance for AI security',
      'Interactive case studies and risk evaluation exercises',
      'Practical mental models applicable immediately'
    ],
    whatNotToExpect: [
      'Hands-on coding or technical implementation labs',
      'Deep technical AI/ML training',
      'Beginner-level AI fundamentals',
      'Tool-specific training (framework-agnostic approach)'
    ],
    whatYouWillReceive: [
      'Comprehensive training slide deck',
      'Executive summary and key takeaways document',
      'Framework reference materials (OWASP, SAIF, CoSAI, AARM)',
      'AI risk assessment templates and checklists',
      'Decision framework for AI use case evaluation',
      'Governance strategy guidelines',
      'References for continued learning and framework deep dives'
    ],
    trainingStructure: [
      {
        part: '1',
        title: 'AI Security Reality Check for Security Leaders',
        topics: [
          'Why AI changes the security operating model',
          'From deterministic systems to probabilistic and autonomous systems',
          'Why traditional controls are not enough for AI systems',
          'The shift from securing systems to governing behavior'
        ]
      },
      {
        part: '2',
        title: 'AI Threat Landscape & Attack Patterns',
        topics: [
          'Prompt injection and instruction hijacking',
          'Data leakage and unsafe disclosure',
          'Tool misuse and indirect execution',
          'Memory poisoning',
          'RAG manipulation and context injection',
          'AI supply chain risks (models, data, embeddings, plugins)',
          'How these attacks appear in real enterprise workflows'
        ]
      },
      {
        part: '3',
        title: 'AI in Security Operations',
        topics: [
          'Where AI helps in SOC, incident response, and threat hunting',
          'Where AI creates false confidence or unsafe automation',
          'AI augmentation versus AI automation',
          'SecOps AI agent concept demonstration'
        ]
      },
      {
        part: '4',
        title: 'Agentic Architecture, RAG, MCP & Autonomous Risks',
        topics: [
          'What makes a system agentic',
          'Core components: model, prompt, memory, tools, orchestration',
          'Attack surface mapping for each component',
          'Risks in RAG architectures',
          'Risks in MCP and tool-connected ecosystems',
          'Why agentic systems behave like privileged insiders if not controlled'
        ]
      },
      {
        part: '5',
        title: 'Framework Landscape: OWASP, SAIF, CoSAI & AARM',
        topics: [
          'OWASP GenAI/LLM Security: Risk taxonomy and attack patterns',
          'Google SAIF: Lifecycle security lens for AI systems',
          'CoSAI: Open ecosystem and standards direction',
          'AARM: Runtime security model for AI actions',
          'How frameworks fit together in the AI security stack'
        ]
      },
      {
        part: '6',
        title: 'AARM Deep Dive: Runtime Security for AI Actions',
        topics: [
          'Why runtime control is required for autonomous systems',
          'The AARM operating model: intercept, evaluate, enforce, record',
          'Action-centric security in practice',
          'How AARM applies to SecOps agents, RAG assistants, and coding agents',
          'How runtime enforcement changes the AI security model'
        ]
      },
      {
        part: '7',
        title: 'AI Security Evals: Quality + Security',
        topics: [
          'Why evals matter for both trust and safety',
          'Quality evals: accuracy, task completion, hallucination rate',
          'Security evals: prompt injection, leakage, unsafe action rate, tool misuse',
          'Why behavior testing matters as much as output testing'
        ]
      },
      {
        part: '8',
        title: 'Prevention, Detection & Response for AI Systems',
        topics: [
          'Prevention: least privilege, tool allowlisting, guardrails, human approval',
          'Detection: anomalous agent behavior, unusual tool usage, context drift',
          'Response: kill switch, session isolation, audit and replay, rollback',
          'Shift from log-based security to behavior-based security'
        ]
      },
      {
        part: '9',
        title: 'Governance, Adoption & Vendor Evaluation for CISOs',
        topics: [
          'AI use-case classification: allowed, restricted, high-risk',
          'Aligning security controls with business adoption',
          'How to evaluate AI vendors and tools',
          'Avoiding becoming the blocker while maintaining control ownership'
        ]
      },
      {
        part: '10',
        title: 'Closing Synthesis: The AI Security Operating Model',
        topics: [
          'Integrated view of threats, architectures, frameworks, runtime control, evals, and operations',
          'Key takeaways: boundaries, privileged insiders, behavior focus, continuous validation',
          'Action items for security leaders',
          'Roadmap for AI security maturity'
        ]
      }
    ]
  },
  23: {
    summary: 'Modern organizations expose thousands of assets across cloud, SaaS, APIs, mobile applications, AI platforms, and third-party services. This hands-on training teaches participants how to perform attacker-grade reconnaissance against modern organizations. Students will learn practical techniques to discover internet-facing assets, map complex attack surfaces, identify AI-related exposures, collect actionable intelligence, and build realistic attack paths using real-world targets and enterprise-scale datasets. The course combines manual tradecraft with automation and AI-assisted workflows to help participants perform faster, more effective reconnaissance while reducing noise.',
    selfCheckQuestions: {
      mainQuestion: 'Do any of these questions come up when you\'re mapping an organization\'s attack surface?',
      questions: [
        'I run subdomain enumeration tools, but am I actually finding the assets that matter or just the easy ones?',
        'How do I discover AI-related exposures : exposed models, datasets, prompt templates : that traditional recon misses?',
        'Am I missing API, mobile, and SaaS attack surface because my recon focuses only on web apps?',
        'How do I use AI to speed up reconnaissance without drowning in noise?',
        'Can I actually chain isolated findings into a realistic, exploitable attack path?',
        'How do I collect actionable intelligence from GitHub, dark web, and leaked credentials without missing what matters?'
      ]
    },
    topics: [
      'Modern Attack Surface Intelligence',
      'Advanced Internet Recon & DNS Intelligence',
      'Modern Asset Discovery (Web Apps, APIs, Mobile, SaaS)',
      'AI Attack Surface Discovery',
      'Hunting AI Exposures & Dataset Discovery',
      'Intelligence Collection (GitHub, Secrets, Dark Web, Credentials)',
      'Cloud Artifact Recon (Docker, Containers, Snapshots)',
      'Attack Surface Validation & Exploitation',
      'AI-Assisted Offensive Reconnaissance',
      'Human Intelligence & Social Engineering',
      'Attack Chaining Methodology',
    ],
    requirements: [
      'Basic understanding of networking and web technologies',
      'Familiarity with Linux command line',
      'Basic knowledge of penetration testing methodologies',
      'Experience with HTTP, DNS, TLS, and common internet protocols (recommended)',
      'No prior experience with reconnaissance tooling required',
      'Laptop capable of connecting to WiFi without restrictive corporate proxies',
      'At least 8 GB RAM (16 GB recommended)',
      'Modern web browser',
      'Ability to install a lightweight VPN client',
      'Administrative privileges on the laptop (recommended)',
      'Cursor, Claude Desktop, or Ollama (optional but recommended for AI exercises)',
    ],
    whatToExpect: [
      'Highly practical, hands-on training with extensive labs',
      'Guided and independent labs based on realistic enterprise environments',
      'Real-world targets for practical exercises',
      'Real-world case studies demonstrating attack methodologies',
      'Capstone exercise: complete reconnaissance engagement against a realistic enterprise target',
    ],
    whatNotToExpect: [
      'Lecture-only format without hands-on practice',
      'Beginner-level fundamentals (this is advanced)',
      'One-on-one mentoring sessions',
    ],
    whatYouWillReceive: [
      'Fully configured cloud-based lab environment',
      'Preconfigured reconnaissance toolkit',
      'Real world targets for practical exercises',
      'Lab manuals and supporting material',
      'Certificate of completion',
    ],
    trainingStructure: [
      {
        part: '1',
        title: 'Day 1: Recon Foundations & Attack Surface Discovery',
        topics: [
          'Module 1: Modern Attack Surface Intelligence',
          'Module 2: Advanced Internet Recon (DNS, Certificates, ASN, BGP, Cloud)',
          'Module 3: Modern Asset Discovery (Web Apps, APIs, Mobile, SaaS, Third-party)',
          'Module 4: Practical Labs',
        ]
      },
      {
        part: '2',
        title: 'Day 2: AI Recon, Intelligence Collection & Exposure Discovery',
        topics: [
          'Module 5: AI Attack Surface Discovery',
          'Module 6: Hunting AI Exposures (Models, Datasets, Prompt Templates)',
          'Module 7: Intelligence Collection (GitHub, Secrets, Dark Web, Credentials)',
          'Module 8: Cloud Artifact Recon (Docker, Containers, Snapshots, Storage)',
          'Module 9: Practical Labs',
        ]
      },
      {
        part: '3',
        title: 'Day 3: Attack Chaining & Offensive Operations',
        topics: [
          'Module 10: Attack Surface Validation',
          'Module 11: AI Assisted Offensive Recon',
          'Module 12: Human Intelligence & Social Engineering',
          'Module 13: Attack Chaining Methodology',
          'Module 14: Capstone Exercise',
        ]
      }
    ],
    suitableFor: [
      'Penetration Testers',
      'Red Team Operators',
      'Security Consultants',
      'Attack Surface Management Teams',
      'Threat Intelligence Analysts',
      'Bug Bounty Hunters',
      'Security Engineers',
      'Detection Engineers',
      'Security Architects',
      'Incident Responders',
      'SOC Analysts interested in offensive tradecraft',
    ],
    benefits: [
      'Perform internet scale reconnaissance against modern organizations',
      'Discover cloud, API, SaaS, mobile, and AI assets',
      'Collect intelligence from public and commercial sources',
      'Identify exposed infrastructure and attack paths',
      'Perform GitHub, credential leak, and third-party reconnaissance',
      'Understand modern AI attack surfaces and how to discover exposures',
      'Automate reconnaissance workflows using AI-assisted techniques',
      'Produce actionable intelligence suitable for penetration testing, red teaming, CTEM, and attack surface management',
      'Fully configured cloud-based lab environment with preconfigured toolkit',
      'Real-world targets and enterprise-scale datasets for practical exercises',
      'Certificate of completion and extended learning materials',
    ],
  },
  24: {
    summary: 'Executive-focused one-day training for CISOs and security leaders to understand AI-native threat landscapes, secure agentic systems, and enable safe AI adoption. Learn practical approaches to threat modeling, framework application (OWASP, SAIF, CoSAI, AARM), runtime security controls, and governance strategies for autonomous AI systems.',
    trainerVideo: {
      url: 'https://www.youtube.com/watch?v=K0Y20dI5sto',
      caption: 'Hear from Avkash and Aashish on what you\'ll learn in this training',
    },
    selfCheckQuestions: {
      mainQuestion: 'As a security leader, do you find yourself asking any of these questions about AI adoption?',
      questions: [
        'How do agentic systems introduce new attack surfaces that traditional controls can\'t address?',
        'What does runtime enforcement actually look like for autonomous AI systems?',
        'How do I evaluate AI use cases from both security and risk perspectives?',
        'What frameworks (OWASP, SAIF, AARM, CoSAI) actually apply to my organization?',
        'How can we enable AI adoption without becoming the bottleneck?',
        'What\'s the difference between securing AI systems and governing AI behavior?'
      ]
    },
    topics: [
      'The AI-Native Threat Model',
      'Understanding the AI Attack Surface',
      'Agent Architecture & Context Security',
      'Securing RAG & Enterprise Knowledge',
      'MCP & Tool Security',
      'Designing an Enterprise AI Security Architecture',
      'AI Security Frameworks & How They Fit Together',
      'Runtime Security for Autonomous Agents',
      'AI Security Evals & Continuous Validation',
      'Governance, Autonomy & Trust'
    ],
    suitableFor: [
      'CISOs and Deputy CISOs',
      'Security Engineering Leaders',
      'SOC and IR Leaders',
      'Enterprise Security Architects',
      'Security leaders responsible for AI adoption and governance'
    ],
    benefits: [
      'Practical mental model for AI-native risk understanding',
      'Decision framework for securing AI adoption across enterprise',
      'Deep understanding of agentic system attack surfaces',
      'Knowledge of runtime enforcement for autonomous systems',
      'Framework evaluation and implementation guidance',
      'Strategies to enable AI without becoming the bottleneck',
      'Prevention, detection, and response playbooks for AI systems'
    ],
    requirements: [
      'Current role in security leadership or governance',
      'Basic understanding of AI/LLM concepts',
      'Experience with security frameworks and risk management',
      'Interest in enterprise AI governance'
    ],
    whatToExpect: [
      'Executive-friendly, discussion-driven format',
      'Real-world attack scenarios and enterprise workflows',
      'Lightweight SecOps AI agent demonstration',
      'Framework landscape overview and practical application',
      'Strategic and tactical guidance for AI security',
      'Interactive case studies and risk evaluation exercises',
      'Practical mental models applicable immediately'
    ],
    whatNotToExpect: [
      'Hands-on coding or technical implementation labs',
      'Deep technical AI/ML training',
      'Beginner-level AI fundamentals',
      'Tool-specific training (framework-agnostic approach)'
    ],
    whatYouWillReceive: [
      'Comprehensive training slide deck',
      'Executive summary and key takeaways document',
      'Framework reference materials (OWASP, SAIF, CoSAI, AARM)',
      'AI risk assessment templates and checklists',
      'Decision framework for AI use case evaluation',
      'Governance strategy guidelines',
      'References for continued learning and framework deep dives'
    ],
    trainingStructure: [
      {
        part: '1',
        title: 'The AI-Native Threat Model',
        topics: [
          'Evolution from LLMs to RAG, agents, MCP, and multi-agent systems',
          'Traditional software security vs. AI-native security',
          'Why autonomous behavior changes the enterprise threat model',
          'Evolution from prompt security to context and runtime security',
          'Understanding AI security as behavioral security'
        ]
      },
      {
        part: '2',
        title: 'Understanding the AI Attack Surface',
        topics: [
          'Prompt injection and indirect prompt injection',
          'Jailbreaks and the alignment vs. security gap',
          'Context and RAG poisoning',
          'Memory poisoning and persistent attacks',
          'Excessive agency and tool abuse',
          'Credential and sensitive-data exposure',
          'AI supply-chain risks',
          'Understanding trust-boundary attacks across AI systems'
        ]
      },
      {
        part: '3',
        title: 'Agent Architecture & Context Security',
        topics: [
          'LLMs vs. autonomous AI agents',
          'How agents observe, reason, plan, act, and adapt',
          'Understanding the agent context stack',
          'System prompts, policies, conversation history, memory, RAG, tools, and MCP',
          'Context engineering as a new security boundary',
          'Short-term, long-term, and shared memory risks',
          'Context isolation and trust'
        ]
      },
      {
        part: '4',
        title: 'Securing RAG & Enterprise Knowledge',
        topics: [
          'Understanding the RAG pipeline and its attack surface',
          'Poisoned documents and knowledge sources',
          'Vector and embedding security risks',
          'Context injection through retrieved content',
          'Over-retrieval and sensitive-data exposure',
          'Treating retrieved content as untrusted input',
          'Least-context and context-verification principles',
          'Auditing what information actually reaches the model'
        ]
      },
      {
        part: '5',
        title: 'MCP & Tool Security',
        topics: [
          'Understanding Model Context Protocol (MCP)',
          'How MCP changes enterprise AI integration',
          'Malicious and compromised MCP servers',
          'Tool poisoning and adversarial tool responses',
          'Permission abuse and excessive privileges',
          'Credential exposure',
          'Third-party MCP supply-chain risks',
          'Applying least privilege and explicit trust to MCP',
          'Human approval for high-risk tool actions'
        ]
      },
      {
        part: '6',
        title: 'Designing an Enterprise AI Security Architecture',
        topics: [
          'Identity and access for users, agents, tools, and services',
          'AI gateways and control planes',
          'Prompt, context, and data protection',
          'Runtime enforcement between agents and enterprise systems',
          'Securing LLMs, RAG, memory, MCP, and tools as a system',
          'Auditability and observability',
          'Identifying and enforcing AI trust boundaries',
          'Why the LLM should never be the policy engine'
        ]
      },
      {
        part: '7',
        title: 'AI Security Frameworks & How They Fit Together',
        topics: [
          'OWASP LLM Top 10: understanding AI application risks',
          'Google SAIF: designing and operating secure AI systems',
          'MITRE ATLAS: understanding adversarial AI techniques',
          'AARM: controlling autonomous actions at runtime',
          'CoSAI: emerging industry security standards',
          'Mapping frameworks to architecture, threat modeling, red teaming, runtime security, and governance'
        ]
      },
      {
        part: '8',
        title: 'Runtime Security for Autonomous Agents',
        topics: [
          'Why static permissions are insufficient for autonomous systems',
          'Moving from access control to behavioral control',
          'Understanding agent intent and execution context',
          'Runtime risk evaluation',
          'Policy-based action enforcement',
          'Runtime decisions: Allow, Deny, Mask, or Require Approval',
          'Human-in-the-loop controls for sensitive actions',
          'Tamper-evident audit trails',
          'Securing the agent harness: identity, context, tools, policies, runtime proxy, and observability'
        ]
      },
      {
        part: '9',
        title: 'AI Security Evals & Continuous Validation',
        topics: [
          'Why one-time AI security testing is insufficient',
          'Security, behavioral, runtime, quality, and human evals',
          'Offline vs. production runtime evals',
          'Testing prompt injection and jailbreak resistance',
          'Testing RAG, memory, MCP, and tool behavior',
          'Validating runtime policies and approval controls',
          'Understanding the limitations of traditional AI red teaming',
          'Continuous security validation: Test → Observe → Attack → Improve → Repeat'
        ]
      },
      {
        part: '10',
        title: 'Governance, Autonomy & Trust',
        topics: [
          'Risk-classifying AI systems and agent actions',
          'Chatbots vs. RAG systems vs. tool-connected agents vs. autonomous agents',
          'Determining which actions can safely be autonomous',
          'Risk-based autonomy and human approval',
          'Least privilege for agents',
          'Context and memory isolation',
          'Continuous audit and accountability',
          'Agent, MCP server, tool, and memory identity',
          'Building explicit trust boundaries across the AI ecosystem'
        ]
      }
    ]
  },
  25: {
    summary: 'This hands-on training teaches you to build AI agents that do your security work: they hunt real vulnerabilities across applications, infrastructure, supply chains, and logs, confirm each one is exploitable, write the fix, open the pull request, ship it, and check that it works. You chain these agents into pipelines that hand work from one to the next, give them memory of your codebase and past incidents so their advice fits your systems instead of the internet at large, add observability so you can trace every decision, and wrap your existing security tools as MCP servers and skills any agent can call. On day one, you create a deliberately vulnerable environment. By day three, your agents have found every flaw in it, fixed it, and shipped the fix, and you haven\'t written a line of application code.',
    trainerVideo: {
      url: 'https://www.youtube.com/watch?v=Ej_dIdpaTAY',
      caption: "Hear from Chandrapal on what you'll build in this training",
    },
    selfCheckQuestions: {
      mainQuestion: 'Do you find yourself asking any of these questions when trying to use AI for security work?',
      questions: [
        'I\'ve used Claude Code or Codex for security tasks, but how do I turn ad-hoc queries into a repeatable pipeline?',
        'How do I know if an AI agent\'s vulnerability finding is real or a hallucination?',
        'What does a multi-agent security pipeline actually look like end-to-end : detection to shipped fix?',
        'How do I give agents memory of my codebase and past incidents instead of generic advice?',
        'Can AI agents really open a PR, deploy the fix, and verify it works without me babysitting every step?',
        'How do I measure and reduce false positives when the output isn\'t deterministic?'
      ]
    },
    topics: [
      'AI Agent Fundamentals : How LLMs reason about security, and choosing the right model, framework, and platform',
      'Building Your First Agent : Setting up a vulnerable environment, and connecting agents to real tools via MCP servers & skills',
      'Agent Architecture Patterns : Autonomous loops, event-triggered, human-in-the-loop, and Ralph loops for continuous testing',
      'Zero-Shot Vulnerability Discovery',
      'Agent Memory & Integration : Giving agents organizational memory and connecting them to your internal systems',
      'Multi-Agent Pipelines : Orchestration, handoffs, shared state, and building an agentic code review pipeline',
      'Domain-Specific Security Agents : Supply chain security, detection rule generation, log anomaly detection, IaC/config review, and DevSecOps automation',
      'Evaluating Models Against Real-World Benchmarks',
      'Observability & Trust : Tracing agent decisions, spotting hallucinations, and reducing false positives',
      'Production Readiness : Automated triage and fix generation, validating non-deterministic outputs, deployment testing, and building reusable agent skills'
    ],
    requirements: [
      'You\'ve done code review, tracked vulnerabilities, or touched CI/CD or Kubernetes, even at a basic level',
      'You\'ve tried Codex, Claude Code, or a similar AI tool for security work, even if the results were mixed or it didn\'t fully click',
      'Python helps but isn\'t required. Agents in this training run on prompt templates, not scripts',
      'No agent framework experience needed. If you\'ve never touched LangChain or MCP, you\'re exactly who this training is built for',
      'Laptop with modern browser and wireless internet connectivity',
      'AWS account with Amazon Bedrock access to LLM models',
      'Personal AWS account with Amazon Bedrock access and administrator permissions.',
      'Around $30-40 in AWS costs across the three days, torn down at the end. Create a new AWS account to get $100 free credits - https://aws.amazon.com/free/',
      'OpenAI or Anthropic subscription is preferable'
    ],
    suitableFor: [
      'Security Engineers',
      'Application Security Engineers',
      'DevSecOps Engineers',
      'Cloud and Kubernetes Security Engineers',
      'Security Architects and Team Leads Evaluating AI for Their Programs',
      'Anyone Who Has Tried Using AI for Security and Wants to Go from Ad-Hoc Queries to a Working Pipeline'
    ],
    whatToExpect: [
      'By the end of Day One, you will have built a working AI agent. It will connect to real security tools and find vulnerabilities in a live environment. Expect hands-on labs from the first hour : no lectures, no theory-only sessions.',
      'By the end of the training, you will leave with a complete multi-agent security pipeline that detects vulnerabilities, validates findings, generates fixes, opens pull requests, and deploys to UAT. The environment you build on Day 1 will be fully patched, and you will not write a line of application code : your agents will.',
      'You will be able to evaluate any model, framework, or platform on your own. Rather than receiving a curated tool list, you will learn the methodology directly, so your evaluation approach remains solid long after the specific tools change.'
    ],
    benefits: [
      'Build AI agents that autonomously discover, validate, and fix real vulnerabilities across apps, infrastructure, and supply chains',
      'Chain multiple agents into a working detection-to-remediation pipeline with shared state and handoffs',
      'Evaluate any AI model, framework, or platform on your own, using a repeatable methodology',
      'Give agents organizational memory so their output reflects your systems, not generic internet advice',
      'Trace every agent decision and spot hallucinations before they become false positives',
      'Wrap existing security tools as MCP servers and skills that any agent can call',
      'Ship agent-generated fixes through a full PR-to-verified-deployment loop without writing application code'
    ],
    whatYouWillReceive: [
      'Dedicated Vulnerable Lab Environment: Each participant receives a vulnerable environment with multiple attack surfaces to work with throughout the training',
      'Lifetime Access to Lab Files and Agent Code: All lab files, agent templates, MCP server code, and setup instructions to reproduce everything in your own environment, with lifetime access',
      'Agent Prompt Template Library: 35+ ready-to-use SKILLS.md files covering CI/CD, infrastructure, application code review, production readiness validation, and continuous monitoring, plus a prompt catalog for detection, triage, fix generation, deployment testing, and validation',
      '30-Day Access to Private Slack Channel: A private channel to ask questions, share agent builds, and continue the conversation after the training',
      'Tool Checklist and Setup Guide: A curated list of all tools, frameworks, MCP servers, and models used in the training with installation instructions and configuration references'
    ],
    trainingStructure: [
      {
        part: '1',
        title: 'Day 1: Foundations, First Agent, Autonomous Hacking',
        topics: [
          'AI Agents 101: How They Work',
          'How LLMs Reason About Security Problems',
          'Choosing the Right Model, Framework, and Platform',
          'Setting Up the Vulnerable Environment',
          'Building Your First AI Agent',
          'Connecting Agents to Real Tools with MCP Servers & Skills',
          'Agent Architecture Patterns: Autonomous Loops, Event-Triggered, Human-In-The-Loop',
          'Ralph Loops for Continuous Security Testing',
          'Zero-Shot Vulnerability Discovery: Your Agent Finds What It\'s Never Seen'
        ]
      },
      {
        part: '2',
        title: 'Day 2: Multi-Agent Pipelines, Context, and Security Domains',
        topics: [
          'Giving Your Agents Organizational Memory',
          'Connecting Agents to Your Internal Systems',
          'From Single Agent to Multi-Agent Pipeline',
          'Multi-Agent Orchestration: Workflows, Handoffs, and Shared State',
          'Building an Agentic Code Review Pipeline',
          'Securing Your Supply Chain with AI Agents',
          'Generating Detection Rules with AI',
          'Finding Anomalies in Logs with AI',
          'Reviewing IaC and Configs with AI Agents',
          'Agentic DevSecOps: Automating Security in Your Pipeline',
          'Evaluating Models Against Real-World Benchmarks'
        ]
      },
      {
        part: '3',
        title: 'Day 3: Observability, Battle Testing, and Production Readiness',
        topics: [
          'Tracing Every Agent Decision',
          'Spotting Hallucinations in Agent Traces',
          'Observability as a Security Control',
          'Measuring and Reducing False Positives',
          'Automating Issue Triage and Fix Generation',
          'Validating Non-Deterministic Outputs You Can Trust',
          'Testing Deployments Automatically',
          'Battle Testing the Full Pipeline',
          'Building Reusable Agent Skills'
        ]
      }
    ]
  },
  26: {
    summary: 'This practical training shows participants how attackers target Kubernetes environments and how defenders can use modern security tools and AI assistance to respond faster. Participants will learn how to find and exploit common Kubernetes misconfigurations, use AI to support reconnaissance and identify attack paths, abuse exposed services, weak RBAC permissions, and privileged workloads, understand attacks against container images and GitOps pipelines, investigate suspicious activity using Kubernetes audit logs and Falco, use K8sGPT to explain cluster problems and suggest remediation, and apply Pod Security Standards and policy-as-code. Participants will learn how to use AI as a practical assistant while validating every finding through Kubernetes data, logs, and security controls.',
    selfCheckQuestions: {
      mainQuestion: 'Do any of these questions sound familiar from your work with Kubernetes?',
      questions: [
        'I know the basics of RBAC, but how do attackers actually chain misconfigurations into cluster compromise?',
        'Can AI actually help me triage a messy cluster faster, or does it just add more noise to investigate?',
        'How do I tell the difference between normal cluster activity and an attacker moving laterally?',
        'What does a real GitOps pipeline compromise look like, and how would I detect it?',
        'Am I using Falco and audit logs effectively, or just collecting data I never review?',
        'How do Pod Security Standards and admission controllers actually stop the attacks I should worry about?'
      ]
    },
    topics: [
      'Kubernetes Architecture & Threat Landscape : Attacker and defender perspectives, control plane mapping, workloads, identities, networking, cloud services',
      'AI/ML-Specific Risks : Understanding AI/ML workloads in Kubernetes, mapping threats to MITRE ATLAS, using AI to understand unfamiliar YAML',
      'Attack Surface Discovery : Identifying exposed services, dangerous permissions, secrets, weak configurations, Kubernetes APIs, and management dashboards',
      'Identity & Access Exploitation : ServiceAccount token abuse, RBAC misconfiguration, privilege escalation, and container escape paths',
      'Persistence Mechanisms : DaemonSet, CronJob, sidecar-based persistence, container-image and registry attacks, GitOps pipeline compromise',
      'Resource Abuse : GPU resource abuse, cryptomining, and workload misconfigurations',
      'Detection & Investigation : Kubernetes audit-log analysis, Falco-based detection, eBPF runtime visibility, investigating pods/identities/processes/network activity',
      'AI-Assisted Troubleshooting : Analyzing cluster problems with K8sGPT, interpreting findings with AI assistance',
      'Pod Security & Access Control : Pod Security Standards, Pod Security Admission, secure contexts, RBAC hardening, NetworkPolicy, zero-trust segmentation',
      'Supply Chain & Policy-as-Code : Image signing, SBOMs, attestations, provenance, Kyverno/Gatekeeper admission controls, AI/ML workload security'
    ],
    requirements: [
      'Comfort with the Linux command line',
      'Familiarity with containers or Docker',
      'Basic Kubernetes knowledge, including Pods, namespaces, YAML and common kubectl commands',
      'Prior penetration-testing experience is useful but not mandatory',
      'Laptop capable of running a modern browser',
      'Ability to access outbound HTTPS and WebSocket connections'
    ],
    suitableFor: [
      'Red teamers and penetration testers',
      'Blue team and SOC engineers',
      'Cloud and Kubernetes security engineers',
      'DevSecOps and platform engineers',
      'Security architects and consultants',
      'Incident-response and threat-hunting teams',
      'AI/ML platform and security engineers',
      'Developers responsible for containerized workloads'
    ],
    whatToExpect: [
      'A highly practical attack-and-defense learning experience',
      'Dedicated browser-based Kubernetes labs',
      'Realistic attack paths based on common cloud-native weaknesses',
      'Hands-on detection engineering and audit-log investigation',
      'Practical incident-response exercises',
      'Supply-chain and policy-as-code implementation',
      'Reusable hardening guidance for production environments',
      'Direct access to the trainer for technical questions during the course'
    ],
    whatNotToExpect: [
      'A beginner Kubernetes administration bootcamp',
      'Certification-exam preparation',
      'Exhaustive coverage of every Kubernetes distribution or cloud provider',
      'Production consulting for an attendee\'s specific organisation',
      'A vendor sales presentation or reliance on commercial security tools'
    ],
    benefits: [
      'Identify and exploit common Kubernetes misconfigurations the way real attackers do',
      'Use AI assistants like K8sGPT to triage unfamiliar clusters and cut investigation time',
      'Detect attacker behavior using Kubernetes audit logs, Falco, and eBPF-based runtime tools',
      'Recognize and defend against container image, registry, and GitOps pipeline compromise',
      'Apply Pod Security Standards, NetworkPolicy, and admission controllers (Kyverno/Gatekeeper) to harden clusters',
      'Map Kubernetes attacks to MITRE ATT&CK and AI-specific threats to MITRE ATLAS',
      'Validate every AI-assisted finding against real cluster data instead of trusting it blindly'
    ],
    whatYouWillReceive: [
      'A 200+ page digital workbook',
      'Individual browser-based Kubernetes lab environments',
      'Continued post-training lab access',
      'Kubernetes incident-response playbooks, hardening and assessment checklists',
      'Detection examples, Kyverno/Spotter policy templates, and supply-chain security implementation examples',
      'Tool-comparison and security-maturity references',
      'Certificate of participation'
    ],
    trainingStructure: [
      {
        part: '1',
        title: 'Understanding the Environment',
        topics: [
          'Kubernetes architecture from an attacker and defender perspective',
          'Mapping the control plane, workloads, identities, networking, and cloud services',
          'Understanding the risks around AI/ML workloads running in Kubernetes',
          'Mapping Kubernetes attacks to MITRE ATT&CK and AI-related threats to MITRE ATLAS'
        ]
      },
      {
        part: '2',
        title: 'AI-assisted Reconnaissance',
        topics: [
          'Using AI to understand unfamiliar Kubernetes YAML and cluster resources',
          'Turning command output into useful investigation questions',
          'Identifying exposed services, dangerous permissions, secrets, and weak configurations',
          'Reviewing AI-generated findings safely and avoiding incorrect recommendations'
        ]
      },
      {
        part: '3',
        title: 'Initial Access and Privilege Escalation',
        topics: [
          'Exposed Kubernetes APIs and management dashboards',
          'Secrets and configuration-data exposure',
          'ServiceAccount token abuse',
          'RBAC misconfiguration and privilege escalation',
          'Privileged pods and container escape paths',
          'Moving from a compromised workload to wider cluster access'
        ]
      },
      {
        part: '4',
        title: 'Persistence and Modern Attack Paths',
        topics: [
          'DaemonSet, CronJob, and sidecar-based persistence',
          'Container-image and registry attacks',
          'GitOps and deployment-pipeline compromise',
          'GPU resource abuse and cryptomining',
          'Risks involving JupyterHub, MLflow, Ray, model files, and AI data pipelines'
        ]
      },
      {
        part: '5',
        title: 'Detection and Investigation',
        topics: [
          'Kubernetes audit-log analysis',
          'Detecting attacker behaviour with Falco',
          'Runtime visibility using eBPF-based tools',
          'Investigating suspicious pods, identities, processes, and network activity',
          'Mapping observed activity to attacker tactics and techniques'
        ]
      },
      {
        part: '6',
        title: 'AI-assisted Triage with K8sGPT & Custom Harness',
        topics: [
          'Analysing cluster problems with K8sGPT',
          'Using natural-language explanations to understand technical findings',
          'Reviewing vulnerability and configuration results from integrated tools',
          'Prioritising issues based on exposure and business impact',
          'Converting findings into clear remediation steps',
          'Understanding where AI recommendations can be incomplete or incorrect'
        ]
      },
      {
        part: '7',
        title: 'Hardening Kubernetes',
        topics: [
          'Pod Security Standards and Pod Security Admission',
          'Secure workload and container security contexts',
          'RBAC and ServiceAccount hardening',
          'Secrets and workload-identity protection',
          'NetworkPolicy and zero-trust segmentation',
          'Admission controls with Kyverno and Gatekeeper',
          'Image signing, SBOMs, attestations, and software provenance',
          'Security controls for AI/ML workloads and data pipelines'
        ]
      }
    ]
  },
  27: {
    summary: 'A hands-on three-day program that takes participants from manual threat modeling to a fully AI-native security practice. Over three days, participants move from strategic context to a fully operational, AI-native security capability. By the close of Day 3, each participant will have stood up both ThreatShield and Secura platforms, built an automated pipeline, wired a CI/CD deployment gate, configured an autonomous incident-response agent, and authored a measurable 30-day transformation roadmap. Participants learn to build autonomous threat models with DREAD, attack trees, ASVS, and DFDs; stand up Secura for AI-driven detection and automated incident response; and design AI-native security processes that scale with engineering velocity.',
    selfCheckQuestions: {
      mainQuestion: 'Do any of these questions come up when you think about scaling your security practice with AI?',
      questions: [
        'My threat modeling is manual and inconsistent : how do I make it automated and repeatable across every project?',
        'How do I go from a pile of scanner alerts to a system that actually triages and responds by itself?',
        'What does an AI-native incident-response agent look like, and can I trust it to act without me?',
        'How do I wire automated threat modeling and deployment gates directly into my CI/CD pipeline?',
        'Can I actually generate audit-ready compliance evidence instead of assembling it manually every cycle?',
        'Where do I even start building a 30-day roadmap to move my team toward AI-native security?'
      ]
    },
    topics: [
      'Why AI-native security is now the only viable posture',
      'The AI threat landscape and shift from bolt-on to architecturally AI-first defense',
      'Autonomous threat modeling with STRIDE, PASTA, OCTAVE frameworks',
      'RAG pipeline and six core threat modeling artefacts',
      'Reading and constructing Data Flow Diagrams (DFDs)',
      'Identifying trust boundaries and DREAD risk scoring',
      'Tracing attacker paths through attack trees',
      'Deploying ThreatShield and configuring organizational context',
      'Integrating automated threat modeling into CI/CD via API and webhooks',
      'The five core roles in an AI-native security team',
      'AI Security Architect function and responsibilities',
      'How AI-assisted review reshapes developer security workflows',
      'Turning raw scanner signals into actionable intelligence',
      'Running a full four-stage detection pipeline',
      'Triaging findings by business risk and exploitability',
      'Designing agent action chains for automated response',
      'Building a working incident-response agent',
      'Measuring effectiveness through MTTR metrics',
      'Standing up the full Secura environment',
      'Wiring SAST, DAST, SCA, and secrets scanners',
      'Connecting Secura with ThreatShield',
      'Mapping platform touchpoints across the SDLC',
      'Designing deployment gates with automation',
      'Generating automated compliance evidence',
      'Custom threat patterns and multi-framework comparison',
      'Agentic-AI risk assessment',
      'Regulatory obligations and audit readiness'
    ],
    requirements: [
      'Basic understanding of security principles and vulnerability assessment',
      'Familiarity with CI/CD pipelines and deployment concepts',
      'Understanding of common vulnerability types (OWASP Top 10)',
      'Comfortable with Linux/command-line basics',
      'Access to a modern web browser',
      'Laptop with stable internet connection'
    ],
    suitableFor: [
      'Security Engineers and Application Security Engineers',
      'DevSecOps Engineers and Platform Security Teams',
      'Security Architects and Security Leaders',
      'Development Team Leads responsible for security practices',
      'Cloud Security and Infrastructure Security Engineers',
      'Organizations building AI-native security programs'
    ],
    whatToExpect: [
      'Hands-on practical labs building threat models and running security platforms',
      'Guided setup of both ThreatShield and Secura in live environments',
      'Working with DREAD scoring, attack trees, DFDs, and ASVS verification',
      'Configuring automated threat modeling in CI/CD pipelines',
      'Building and testing AI-driven detection and incident-response agents',
      'Creating a personalized 30-day transformation roadmap for your organization',
      'Direct access to the trainer for technical guidance throughout the course',
      'Capstone presentation and peer feedback sessions'
    ],
    benefits: [
      'Build autonomous threat models using DREAD scoring, attack trees, and DFDs instead of manual spreadsheets',
      'Wire automated threat modeling directly into CI/CD via API and webhooks',
      'Stand up an AI-driven detection pipeline that turns raw scanner noise into triaged, actionable findings',
      'Configure a working incident-response agent and measure its impact through MTTR',
      'Connect SAST, DAST, SCA, and secrets scanners into a single AI-orchestrated security platform',
      'Design deployment gates that generate audit-ready compliance evidence automatically',
      'Leave with a personalized 30-day roadmap to move your organization toward AI-native security'
    ],
    whatYouWillReceive: [
      'AI-powered detection and incident-response agent templates',
      'Comprehensive training materials and platform documentation',
      'A personalized 30-day rollout roadmap tailored to your organization',
      'Operational playbooks for embedding AI-native workflows into the SDLC',
      'Automated compliance evidence generation examples',
      'Access to trainer support for post-training implementation questions'
    ],
    trainingStructure: [
      {
        part: '1',
        title: 'Module 1: The AI Revolution and Security Challenges',
        topics: [
          'Why AI-native security is now the only viable posture',
          'The AI threat landscape evolution',
          'Shift from bolt-on to architecturally AI-first defense',
          'Strategic context for AI in security operations'
        ]
      },
      {
        part: '2',
        title: 'Module 2: Introduction to ThreatShield',
        topics: [
          'Autonomous threat modeling platform overview',
          'STRIDE, PASTA, OCTAVE framework selection',
          'The RAG pipeline and six core artefacts',
          'Hands-on: First threat model generation'
        ]
      },
      {
        part: '3',
        title: 'Module 3: DREAD, Attack Trees, ASVS & DFDs',
        topics: [
          'Reading and constructing Data Flow Diagrams (DFDs)',
          'Identifying trust boundaries in system architecture',
          'DREAD risk scoring methodology and practice',
          'Tracing attacker paths through attack trees',
          'ASVS verification test cases'
        ]
      },
      {
        part: '4',
        title: 'Module 4: Setting Up ThreatShield in Your Pipeline',
        topics: [
          'Deploying ThreatShield in your environment',
          'Configuring organizational context and artifact inputs',
          'Integrating automated threat modeling into CI/CD via API',
          'Setting up webhooks for automated model updates'
        ]
      },
      {
        part: '5',
        title: 'Module 5: Building an AI-Native Security Team',
        topics: [
          'The five core roles in an AI-native security team',
          'AI Security Architect function and responsibilities',
          'How AI-assisted review reshapes developer workflows',
          'Structuring security and engineering collaboration'
        ]
      },
      {
        part: '6',
        title: 'Module 6: AI for Threat Detection & Intelligence',
        topics: [
          'Turning raw scanner signals into actionable intelligence',
          'Running a full four-stage detection pipeline',
          'Correlating findings across multiple scanners',
          'Triaging findings by business risk and exploitability',
          'Enriching alerts with context and remediation guidance'
        ]
      },
      {
        part: '7',
        title: 'Module 7: Automated Incident Response with AI',
        topics: [
          'Designing agent action chains for automation',
          'Building a working incident-response agent on Secura',
          'Automating remediation pull request creation',
          'Escalation and routing policies',
          'Measuring effectiveness through MTTR metrics'
        ]
      },
      {
        part: '8',
        title: 'Module 8: Setting Up Secura',
        topics: [
          'Standing up the full Secura environment',
          'Wiring SAST, DAST, SCA, and secrets scanners',
          'Connecting Secura with ThreatShield outputs',
          'Configuring enrichment and remediation pipelines'
        ]
      },
      {
        part: '9',
        title: 'Module 9: Developing AI-Native Security Processes',
        topics: [
          'Mapping platform touchpoints across the SDLC',
          'Designing deployment gates with AI-native controls',
          'Generating automated compliance evidence',
          'Audit-ready artifact generation',
          'Process documentation and team enablement'
        ]
      },
      {
        part: '10',
        title: 'Module 10: Advanced Use Cases, Future Trends & Capstone',
        topics: [
          'Custom threat patterns and framework comparison',
          'Agentic-AI risk assessment and governance',
          'Regulatory obligations and compliance strategies',
          'Future trends in AI-native security',
          'Building your personalized 30-day transformation roadmap',
          'Capstone presentation and peer feedback'
        ]
      }
    ]
  },
  28: {
    summary: 'A 1-day intensive, hands-on workshop designed to teach engineers how to build, break, and defend modern software supply chains. Moving beyond basic compliance, this course forces students to think like attackers while building robust, automated defensive pipelines. Students will transform a raw developer environment into a fortified, AI-defended, and monitored software delivery machine. Learn to integrate secret scanning, manipulate git histories to overwrite leaked credentials, engineer a custom AI-driven SAST GitHub Action using LLMs, deploy autonomous pentesting agents, construct centralized telemetry dashboards, engineer Slack ChatOps integrations, and deploy AWS Lambda guardrails to enforce branch protection and detect privileged cloud actions in real-time.',
    selfCheckQuestions: {
      mainQuestion: 'Do any of these questions come up when you think about your CI/CD pipeline\'s security?',
      questions: [
        'I know secrets get leaked into git history : but do I actually know how to scrub and remediate them properly?',
        'Are rule-based scanners catching what matters, or am I drowning in false positives I\'ve learned to ignore?',
        'What does an autonomous AI pentesting agent actually find in a real pipeline that I\'d otherwise miss?',
        'How do I get security alerts into Slack in a way engineers actually act on instead of ignoring?',
        'Would I even notice if someone quietly disabled branch protection or took a privileged AWS action right now?',
        'How do I build real-time guardrails instead of relying on periodic compliance audits?'
      ]
    },
    topics: [
      'IDE, GitHub, and AWS CLI setup',
      'Branching strategies and environment isolation',
      'GitHub Actions 101',
      'Hunting secrets with TruffleHog',
      'Git rewrite and credential remediation',
      'Traditional rule-based scanner limitations',
      'Building custom AI static code scanners using Claude API',
      'GitHub Actions for automated code review',
      'Deploying vulnerable applications to AWS',
      'Shannon AI and autonomous pentesting',
      'AI agent attack loop execution',
      'Centralizing JSON telemetry from GitHub Actions',
      'Building Flask Security Dashboards',
      'Slack Webhooks integration',
      'ChatOps for actionable alerts',
      'AWS Cloud auditing and configuration drift detection',
      'AWS EventBridge rules for privileged actions',
      'Lambda functions for real-time alerting',
      'GitHub API branch protection drift detection',
      'Reviewing AI exploit chains'
    ],
    requirements: [
      'Basic understanding of Git and GitHub (commits, branches, pull requests)',
      'Familiarity with the command line and basic Python scripting',
      'Conceptual understanding of CI/CD pipelines',
      'Basic familiarity with AWS services (EC2, Lambda, IAM, CloudTrail)',
      'Local administrative privileges on your laptop'
    ],
    suitableFor: [
      'Security Engineers & AppSec Professionals',
      'DevOps/Platform Engineers',
      'Software Developers',
      'Penetration Testers',
      'Cloud Security Engineers',
      'Engineers responsible for CI/CD pipeline security'
    ],
    whatToExpect: [
      'Hands-on labs building AI-driven SAST scanners',
      'Practical exercises in git history manipulation and secrets remediation',
      'Deploying and attacking real vulnerable applications',
      'Building working telemetry dashboards and ChatOps integrations',
      'Configuring AWS Lambda guardrails and EventBridge monitoring',
      'End-to-end CI/CD pipeline security hardening',
      'Direct access to trainer for technical guidance'
    ],
    whatNotToExpect: [
      'Extended multi-day coverage : this is a 1-day intensive, not a gradual ramp-up',
      'Coverage of CI/CD platforms or cloud providers beyond GitHub Actions and AWS',
      'Beginner-level Git or CI/CD fundamentals instruction',
      'Theory-only lectures without hands-on pipeline building',
      'Production-grade enterprise rollout guidance : labs are scoped to a self-contained training environment'
    ],
    benefits: [
      'Weaponize AI for static code analysis by building a custom LLM-based SAST scanner',
      'Remediate leaked secrets properly : including safely rewriting git history to scrub exposed credentials',
      'Deploy an autonomous AI pentesting agent and interpret its attack chains against a live target',
      'Build real-time ChatOps alerting so security findings reach engineers where they already work',
      'Detect privileged AWS actions and branch protection drift as they happen, not after an audit',
      'Think like an attacker while engineering the automated defenses that stop that exact attacker'
    ],
    whatYouWillReceive: [
      'Comprehensive slide deck covering all training material',
      'Workbooks with detailed lab instructions and exercises',
      'Answer sheets for all practical labs and challenges',
      'Access to lab environment for 1 week after the training concludes'
    ],
    trainingStructure: [
      {
        part: '1',
        title: 'Module 1: The DevSecOps Environment',
        topics: [
          'IDE, GitHub, and AWS CLI setup',
          'Branching strategies (default, dev, prod)',
          'Environment isolation and best practices'
        ]
      },
      {
        part: '2',
        title: 'Module 2: Pipeline Foundations & The Secret Leak',
        topics: [
          'GitHub Actions 101',
          'Hunting secrets: Integrating TruffleHog',
          'Blocking PRs on secret detection',
          'The Git Rewrite adversarial lab',
          'Overwriting commits to scrub leaked keys',
          'Key rotation and remediation strategies'
        ]
      },
      {
        part: '3',
        title: 'Module 3: AI-Driven Static Code Analysis (SAST)',
        topics: [
          'Limitations of traditional rule-based scanners',
          'Building custom AI static scanners using Claude API',
          'Engineering GitHub Actions for automated code review',
          'Writing AI SAST GitHub Actions',
          'Piping dev branch pushes to AI for sanitization'
        ]
      },
      {
        part: '4',
        title: 'Module 4: Autonomous DAST & Attack Launch',
        topics: [
          'Deploying target environments to AWS',
          'Introduction to Shannon AI autonomous pentesting',
          'Initiating background Shannon AI attack loops',
          'Mapping attack paths against targets'
        ]
      },
      {
        part: '5',
        title: 'Module 5: Telemetry, Observability & ChatOps',
        topics: [
          'Centralizing JSON telemetry from GitHub Actions',
          'Building Flask Security Dashboards',
          'Parsing TruffleHog and AI SAST outputs',
          'Slack Webhooks integration with GitHub Actions',
          'ChatOps labs for actionable developer alerts',
          'Context-rich security notifications'
        ]
      },
      {
        part: '6',
        title: 'Module 6: Cloud Posture & Guardrails',
        topics: [
          'Reviewing Shannon AI exploit chains',
          'Feeding attack data into security dashboards',
          'AWS Cloud auditing and configuration drift detection',
          'AWS EventBridge rules for privileged actions',
          'Lambda functions for instant Slack alerts',
          'GitHub API monitoring for branch protection drift',
          'AWS Lambda guardrails for enforcement'
        ]
      }
    ]
  },
  29: {
    summary: 'A 3-day hands-on training covering blockchain fundamentals, smart contract security in Solidity, and real-world exploit techniques. Blockchains now power real financial infrastructure : DeFi, stablecoins, prediction markets, RWAs : where the deployed code is the final authority and a shipped bug can\'t simply be patched away. This course builds the security instinct needed to work in that environment through live exploitations and defensive practice. Students go from consensus and EVM fundamentals, through Solidity and day-to-day tooling, into a graded sequence of real exploit classes, and finally into the DeFi protocols where those attacks actually land. Every concept is paired with a lab: deploy a vulnerable contract, break it, then fix it.',
    selfCheckQuestions: {
      mainQuestion: 'Do any of these questions come up when you think about smart contract security?',
      questions: [
        'I understand Solidity syntax, but can I actually spot a reentrancy or oracle manipulation vulnerability by reading code?',
        'How do famous DeFi exploits actually work step by step, and could I reproduce one myself?',
        'Am I using Slither and Mythril effectively, or just running them and hoping they catch everything?',
        'How does MEV actually get exploited in practice, and what does it mean for contract design?',
        'Since deployed contracts can\'t simply be patched, how do I build in defenses before launch instead of after?',
        'Do I understand EVM internals well enough to know why a "safe-looking" contract might still be exploitable?'
      ]
    },
    topics: [
      'Blockchain & Consensus Fundamentals : Blockchain basics, Proof-of-Work, Proof-of-Stake, Tendermint, and permissionless transaction system security',
      'Solidity & EVM Architecture : Solidity language, EVM storage, call flow, transaction lifecycle, and contract tooling',
      'Smart Contract Development & Testing : Local networks, testnets, deployment patterns, testing contracts, and mainnet workflows',
      'Vulnerability Classes: Memory & Access : Integer overflow/underflow, reentrancy attacks and variants, broken access control',
      'Vulnerability Classes: External Dependencies : Oracle manipulation, flash loan patterns and exploitation, economic and business-logic attacks',
      'MEV & Transaction Ordering : MEV fundamentals, frontrunning and sandwich attacks, transaction-order attacks, and protocol defenses',
      'DeFi Protocol Patterns : DeFi building blocks (Uniswap and Aave patterns), protocol-specific risks, and economic exploits',
      'Web3 Specific Risks : NFT-specific vulnerabilities, Web3 attack vectors, and emerging security concerns',
      'Analysis & Automated Tools : Automated analysis with Slither and Mythril, vulnerability detection, and security scanning',
      'Audit & Security Practices : Smart contract review basics, auditing methodology, and participating in Web3 bug bounties'
    ],
    requirements: [
      'Some programming or scripting experience in any language (Python or JavaScript helps, but isn\'t required)',
      'Comfort with the command line',
      'Solidity is a plus but not required:it\'s taught from the ground up',
      'Prior blockchain exposure is helpful but not mandatory',
      'No smart-contract auditing background needed',
      'Laptop with administrator/root access',
      'Able to run Docker containers (required)',
      'Able to run a virtual machine if needed',
      '8 GB RAM minimum, 16 GB preferred; ~20 GB free disk space',
      'A modern browser; Git client is handy'
    ],
    suitableFor: [
      'Blockchain and smart-contract developers',
      'Application security engineers and pentesters moving into Web3',
      'Security engineers reviewing DeFi, wallets, or on-chain integrations',
      'Researchers and enthusiasts who want practical offensive skills',
      'Protocol/market analysts who need a real technical security foundation',
      'Auditors and red-teamers early in their smart-contract work'
    ],
    whatToExpect: [
      'Real practice exploiting and fixing each vulnerability class, not just watching',
      'A working mental model of EVM execution, storage, and transaction security',
      'Hands-on fluency with Solidity security tooling (Slither, Mythril)',
      'The ability to map DeFi primitives into concrete attack paths',
      'Lecture materials and a Docker-based lab environment to keep',
      'A grounded look at bug bounties and blockchain security careers',
      'Instruction that comes out of real conference training and day-job practice, not theory',
      'Interactive lecture format running straight into continuous hands-on labs'
    ],
    whatNotToExpect: [
      'A multi-week Solidity developer bootcamp or a language certification',
      'To walk out audit-certified:this is a strong foundation plus an attack lab, not a sign-off credential',
      'Deep coverage of every L1/L2 and non-EVM chain:the focus is Ethereum/EVM',
      'Any live mainnet attacking:all labs are local/test and strictly educational',
      'Commercial/enterprise tool licenses'
    ],
    benefits: [
      'Read Solidity code and spot reentrancy, oracle manipulation, and overflow vulnerabilities on sight',
      'Reproduce famous real-world DeFi exploits in a safe lab environment, then patch them',
      'Use Slither and Mythril effectively as part of a real audit workflow, not just as a checkbox scan',
      'Understand EVM internals well enough to explain why a "safe-looking" contract can still be exploitable',
      'Recognize how MEV gets exploited in practice and design contracts that account for it',
      'Build the security instinct needed to audit contracts where a shipped bug can\'t simply be patched'
    ],
    whatYouWillReceive: [
      'Lecture materials and reference deck for future study',
      'Docker images with live demos, vulnerable labs, and tooling',
      'Lab instructions aligned to each attack module',
      'Vulnerable contract examples to deploy and practice with',
      'Pointers for further reading and tooling resources',
      'Security checklist and career guidance in blockchain security',
      'Lifetime access to lab environment and materials'
    ],
    trainingStructure: [
      {
        part: '1',
        title: 'Day 1: Foundations and First Exploits',
        topics: [
          'Origins of smart contracts and decentralized trust',
          'Consensus mechanisms: Proof-of-Work, Proof-of-Stake, Tendermint',
          'Threat model for on-chain applications',
          'Solidity essentials',
          'EVM storage, call flow, and transaction lifecycle',
          'Environment setup with Docker images',
          'Deploy and test on a local network',
          'First vulnerable contracts hands-on',
          'Classic bug classes: integer overflow/underflow',
          'Access-control mistakes',
          'First reentrancy exploit (students write and run themselves)'
        ]
      },
      {
        part: '2',
        title: 'Day 2: Advanced Attacks, Tooling, and DeFi Ecosystem',
        topics: [
          'Deeper reentrancy variants',
          'Business-logic attacks',
          'Economic attacks',
          'Oracle manipulation patterns',
          'Flash-loan attack patterns',
          'Security tooling: Slither for static analysis',
          'Security tooling: Mythril for dynamic analysis',
          'Finding real issues and verifying fixes',
          'DeFi protocol patterns: Uniswap-style integrations',
          'DeFi protocol patterns: Aave-style integrations',
          'DeFi protocols as attack surface',
          'NFT attack and manipulation walkthrough',
          'Defensive guidance and best practices',
          'Bug-bounty landscape and career paths',
          'MEV and ordering attacks overview'
        ]
      },
      {
        part: '3',
        title: 'Day 3: MEV, Node-Level Advantage, and Capstone',
        topics: [
          'MEV and node-level advantage explained',
          'Frontrunning attacks and defenses',
          'Sandwich attacks and detection',
          'Transaction-order dependence',
          'MEV exploitation shown live',
          'Private mempools and Flashbots-style approaches',
          'Mitigations and defensive strategies',
          'Capstone lab: multi-step exploit chain combining DeFi primitives',
          'Hardening checklist and remediation strategies',
          'Open Q&A and discussion',
          'Career guidance in Web3 security'
        ]
      }
    ]
  },
  30: {
    trainerVideo: {
      url: 'https://www.youtube.com/watch?v=bCYmEgusnt4',
      caption: "Meet your trainers, Anant and Riyaz, and see what you'll build in this training",
    },
    summary: 'Most teams only ever meet a CSPM as a closed dashboard someone else built or as a SaaS interface. This training exists so you understand posture management from the inside and can build one you control. Cloud estates now span multiple providers, thousands of identities, and a growing set of AI agents, and the misconfigurations that actually hurt are the ones that chain together across those boundaries. Knowing how detection, prioritization, and remediation really work, and being able to change any of it, is what separates operating a tool from depending on a vendor. You leave with a reproducible stack, a reusable policy library, and an architecture you can drop into your own environment, plus the judgment to extend or replace any part of it.',
    selfCheckQuestions: {
      mainQuestion: 'Do any of these questions come up when you think about your cloud security posture?',
      questions: [
        'Are you stuck depending on a vendor\'s CSPM dashboard instead of understanding how it actually detects and prioritizes risk?',
        'Can you build multi-cloud asset inventory and an attack-path graph that spans AWS, Azure, and GCP from a single collector?',
        'Do you know how to write custom policy-as-code that maps to CIS Benchmarks and your own controls, instead of relying on built-in checks alone?',
        'How would you move from point-in-time scans to continuous, event-driven detection and prioritize by real risk instead of raw finding counts?',
        'Could you remediate a misconfiguration safely, with dry-run, approval gates, and rollback, instead of scripting a risky one-off fix?',
        'Do you know how to add an AI layer for triage and natural-language querying without introducing prompt-injection or confused-deputy risk?'
      ]
    },
    topics: [
      'CSPM Architecture & the Cloud-Agnostic Collector',
      'Asset Inventory & Attack-Path Mapping',
      'Configuration Assessment & Policy-as-Code',
      'Compliance Reporting & Data Normalization (OCSF)',
      'Continuous Monitoring & Alerting',
      'Event-Driven Detection & Risk Prioritization',
      'Remediation with Guardrails',
      'AI-Assisted CSPM',
      'Capstone Validation',
      'CSPM over MCP and Attacking It',
    ],
    requirements: [
      'Laptop running macOS, Linux, or Windows 10/11 with WSL2, with administrator/root access (64-bit; Apple Silicon and x86-64 both fine)',
      'Minimum 16 GB RAM and 50 GB free SSD space',
      'Hardware virtualization enabled (required by Docker and WSL2)',
      'Docker Desktop (4.0+) or Docker Engine with Compose v2 plugin on Linux, installed and functional',
      'Git installed',
      'AWS CLI v2, Azure CLI, and gcloud CLI installed and authenticated to your own accounts',
      'Modern web browser (Chrome or Firefox recommended) for Neo4j Browser, Powerpipe/Evidence dashboards, and the OPA playground',
      'SSH client and a code editor (VS Code recommended) for editing Rego, YAML, SQL, and Python',
      'Active AWS, Azure, and GCP accounts where you can create and delete resources, with sufficient privilege to run provisioning scripts',
      'A budget alert set on your cloud accounts (lab resources incur small charges; teardown scripts are provided)',
    ],
    whatToExpect: [
      'A lab-heavy format focused on building and operating, not watching slides',
      'A working reference implementation you leave with, plus reusable policies',
      'A clearer model for connecting inventory, findings, policy logic, and response workflows across multiple clouds',
      'Full visibility into detection logic via an open-source approach, with freedom to customize every control',
    ],
    whatNotToExpect: [
      'Defensive security in terms of fixing misconfigurations',
      'Extrapolating the learnings to scale and load balancing',
      'Lots of theory',
    ],
    whatYouWillReceive: [
      'Detailed documentation and setup steps',
      'Instructions to manage and operate the labs once created',
      'All scripts required to run the labs and tear them down as needed',
    ],
    trainingStructure: [
      {
        part: '1',
        title: 'Day 1: Building the Cloud-Agnostic Collector',
        topics: [
          'Module 1: CSPM Architecture & the Cloud-Agnostic Collector (five core capabilities, one control plane reaching all three clouds by credentials, lab setup and validation)',
          'Module 2: Asset Inventory & Attack-Path Mapping (Steampipe into PostgreSQL, Cartography + Neo4j, exposure paths, least privilege for the scanner)',
          'Module 3: Configuration Assessment & Policy-as-Code (Prowler across AWS, Azure, GCP, OCSF output, OPA/Rego custom policies, reusable policy library)',
          'Module 4: Compliance Reporting & Data Normalization (OCSF as the shared schema, Powerpipe benchmarks, Evidence dashboards, audit-ready exports)',
        ]
      },
      {
        part: '2',
        title: 'Day 2: Operationalizing and Adding AI',
        topics: [
          'Module 5: Continuous Monitoring & Alerting (scheduled scans, change detection, alert-only-on-new, Slack and email notifications)',
          'Module 6: Event-Driven Detection & Risk Prioritization (CloudTrail, Azure Activity Logs, GCP Cloud Audit Logs, toxic-combination scoring from the graph)',
          'Module 7: Remediation with Guardrails (dry-run, approval gates, logging, rollback, Python and Flowpipe)',
          'Module 8: AI-Assisted CSPM (finding triage, enrichment, natural-language querying over PostgreSQL and Neo4j, local or cloud models)',
          'Module 9: Capstone Validation (instructor-injected misconfigurations, scored end-to-end detection, triage, alert, and remediation)',
          'Module 10: Advanced Enhancement, CSPM over MCP and Attacking It (MCP server over your data, prompt injection through findings, confused-deputy, guardrails)',
        ]
      }
    ],
    suitableFor: [
      'Cloud Security Engineers',
      'DevSecOps Practitioners',
      'Blue Team Operators',
      'Cloud Architects with security responsibilities',
      'SOC Analysts working with cloud environments',
      'Security Consultants who assess cloud infrastructure',
    ],
    benefits: [
      'Stand up a cloud-agnostic CSPM that reaches AWS, Azure, and GCP from a single collector using scoped credentials, and secure that collector as the credential boundary it is',
      'Build multi-cloud asset inventory and an attack-path graph, and query both to answer real exposure questions',
      'Run configuration assessment across all three clouds and write custom policy-as-code that maps to CIS Benchmarks and your own controls',
      'Normalize findings to a shared schema (OCSF) and produce audit-ready compliance reporting for analysts, auditors, and leadership',
      'Move from point-in-time scans to continuous and event-driven detection, and prioritize by real risk (toxic combinations) instead of raw finding counts',
      'Remediate safely with dry-run, approval gates, logging, and rollback',
      'Add an AI layer for finding triage and natural-language querying, and recognize the new attack surface it introduces, including prompt injection through findings and confused-deputy risk when an AI agent holds cloud credentials',
    ],
  },
  31: {
    summary: 'Intensive 2-day training focused on threat hunting through memory forensics — detecting, investigating, and analyzing sophisticated malware, APTs, and rootkits hidden in memory using the Volatility framework, with realistic crimeware, APT, and rootkit-infected memory images.',
    topics: [
      'Memory Acquisition & Volatility Framework',
      'Process Internals & Malware Process Detection',
      'Process Handles, Mutex & Registry Persistence Analysis',
      'Network Activity Investigation via Memory',
      'Process Memory, DLL Analysis & YARA Scanning',
      'User-Mode Rootkits, Fileless Malware & Code Injection',
      'Kernel-Mode Rootkit Investigation',
    ],
    requirements: [
      'Laptop running macOS, Linux, or Windows 10/11 with administrator/root access',
      'Minimum 8 GB RAM and 30 GB free disk space',
      'No prior memory forensics experience required — suitable for beginner through advanced attendees',
    ],
    suitableFor: [
      'Forensic practitioners and incident responders',
      'Threat hunters and malware analysts',
      'Cyber-security investigators and security researchers',
      'System administrators and software developers',
      'Students and anyone interested in learning malware analysis',
    ],
    whatToExpect: [
      'A hands-on, lab-driven format using realistic crimeware, APT, and rootkit-infected memory images',
      'Deep-dive into Windows internals — process structures, DKOM, code injection, and kernel-mode rootkit techniques',
      'Scenario-based investigations building toward independently analyzing malware-infected memory',
    ],
    whatNotToExpect: [
      'A tool-certification course — this is investigative technique, not a product certification',
      'Coverage of live/endpoint telemetry or network-layer forensics — the training is scoped entirely to memory forensics',
      'Lecture-only content with no hands-on labs',
    ],
    whatYouWillReceive: [
      'Detailed lab documentation and Volatility setup steps',
      'Sample crimeware, APT, and rootkit-infected memory images used in class',
      'Certificate of participation',
    ],
    trainingStructure: [
      {
        part: '1',
        title: 'Day 1: Memory Acquisition, Volatility & Process Investigation',
        topics: [
          'Module 1: Introduction to Memory Forensics (acquisition from physical & virtual machines)',
          'Module 2: Volatility Overview (installation, profiles, plugins)',
          'Module 3: Investigating Process (EPROCESS internals, DKOM attacks, malware process identification)',
          'Module 4: Investigating Process Handles & Registry (mutex analysis, persistence detection)',
        ],
      },
      {
        part: '2',
        title: 'Day 2: Network Artifacts, Code Injection & Rootkits',
        topics: [
          'Module 5: Investigating Network Activities (connections, sockets in memory)',
          'Module 6: Investigating Process Memory (DLL dumping, yarascan)',
          'Module 7: User-Mode Rootkits & Fileless Malware (code injection techniques, case study)',
          'Module 8: Kernel-Mode Rootkits (functional call traversal, hooking, kernel plugins)',
        ],
      },
    ],
    benefits: [
      'Practical skills in memory acquisition and the Volatility framework',
      'Ability to detect and analyze sophisticated malware, APTs, and rootkits hidden in memory',
      'Understanding of adversary stealth techniques used to evade live forensic tools',
      'Hands-on experience investigating code injection and kernel-mode rootkit techniques',
      'Instruction from the co-founder of Cysinfo and a working malware researcher',
    ],
  },
  32: {
    summary: 'This program is designed to bridge the gap between AI innovation and executive accountability. It provides a comprehensive deep dive into the Artificial Intelligence Management System (AIMS), equipping C-suite professionals with the framework to manage the probabilistic risks of AI while ensuring compliance with global and Indian regulatory mandates (RBI, EU AI Act, DPDP). The course moves beyond theoretical ethics into practical implementation, utilizing the ISO/IEC 42001 and NIST AI RMF 1.0 standards to create a "defensible AI strategy" for the enterprise.',
    topics: [
      'Global and Indian AI regulatory landscape (EU AI Act, RBI Directions, DPDP) and its impact on BFSI and technology sectors',
      'AI-specific risks (Bias, Hallucinations, Model Drift, Opacity) vs. traditional IT Risk Management',
      'Integrating AI Governance into existing compliance frameworks — SOC 2, PCI DSS, and ISO 27001',
      'Strategic governance activities: AI Impact Assessments (AIA), Shadow AI discovery, and drafting "Acceptable Use" policies',
      'Mapping the AI lifecycle to ISO/IEC 42001 clauses and NIST AI RMF functions (Govern, Map, Measure, Manage)',
    ],
    requirements: [
      'Basic understanding of AI terminologies, legal requirements, and CXO-level expectations on AI Governance',
      'A laptop with basic MS Office or equivalent tools',
    ],
    suitableFor: [
      'CXOs and C-Suite executives',
      'Legal Counsel to C-Suite / Board',
      'Board members responsible for AI risk oversight',
    ],
    whatToExpect: [
      'Strategic clarity on how AI risks (bias, hallucination, drift) translate into financial and legal liabilities',
      'A "defensible" framework: hands-on experience mapping organizational goals to ISO/IEC 42001 and NIST AI RMF 1.0',
      'A practical breakdown of complying with the EU AI Act, RBI Directions, and India\'s DPDP Act without slowing down innovation',
      'Ready-to-use governance toolkits — AI Acceptable Use Policies, Vendor Audit Checklists, and AI Impact Assessments (AIA)',
      'Actionable methods to identify and manage "Shadow AI" (unauthorized employee use of tools like ChatGPT) within the enterprise',
      'Clear accountability mapping — defining exactly who (CEO, CIO, CISO, or Legal) owns which part of the AI risk lifecycle',
    ],
    whatNotToExpect: [
      'Coding or Data Science — this is not a technical "how-to" on building models, writing Python code, or training neural networks',
      'Prompt engineering tips or a productivity workshop for daily AI use',
      'Speculative "sci-fi" AI hype — the focus is entirely on current, real-world business and regulatory risks',
      'Standard IT Governance checklists — AI governance is probabilistic, not deterministic, and traditional ISO 27001 checklists are not sufficient alone',
      'A substitute for formal legal counsel — this is a framework for building a compliant management system, not a legal "silver bullet"',
    ],
    whatYouWillReceive: [
      'AI Acceptable Use Policy (Template)',
      'AI Vendor Risk Assessment Checklist',
      'NIST/ISO 42001 Mapping Spreadsheet',
      'AI Incident Response Playbook',
    ],
    trainingStructure: [
      {
        part: '1',
        title: 'The AI Regulatory Landscape & GRC Frameworks',
        topics: [
          'The Governance Mandate: why AI Governance matters (moving from "Shadow AI" to predictable ROI)',
          'EU AI Act: Prohibited vs. High-Risk systems; Conformity Assessments and fines up to 7% of turnover',
          'RBI Directions: Explainability, Customer Data protection, and Algorithmic Transparency in Lending/Fraud',
          'DPDP Act (India): managing personal data processing within Large Language Models (LLMs)',
          'Case Studies: real-world AI failures — biased hiring algorithms, chatbot financial liability, data leakage incidents',
        ],
      },
      {
        part: '2',
        title: 'Secure AI System Lifecycle Management',
        topics: [
          'The AI Lifecycle: from Design and Data Acquisition to Model Tuning and Retirement',
          'NIST AI RMF: applying the "Map" and "Measure" functions to the development pipeline',
          'ISO 42001 Annex A: implementing technical controls for data quality and model robustness',
          'Secure Integration: managing the "AI Bill of Materials" (AIBOM) for 3rd-party SaaS vendors',
        ],
      },
      {
        part: '3',
        title: 'AI Risk Management & Impact Assessments',
        topics: [
          'Risk Assessment vs. Impact Assessment (AIA): technical failure (accuracy, drift, security) vs. societal and human rights consequences (bias, equity, privacy)',
          'ISO Clauses 6.1.2 & 6.1.3: practical application of AI risk treatment plans',
          'Compliance Overlap: how AI governance satisfies requirements for SOC 2 (Trust Services Criteria) and PCI DSS (Secure Data Handling)',
        ],
      },
      {
        part: '4',
        title: 'Leadership Role & Ethical AI (ISO Clause 5)',
        topics: [
          'C-Suite Accountability: defining roles for the AI Governance Council',
          'Clause 5.1 (Leadership & Commitment): ensuring AI policy is integrated into business processes',
          'Ethical AI Pillars: Transparency, Fairness, Sustainability, and Human Agency',
          'Workshop: drafting the "AI Red Lines" — where the organization will not use AI',
        ],
      },
      {
        part: '5',
        title: 'Managing "Shadow AI" & Operational Resilience',
        topics: [
          'Shadow AI Discovery: identifying employee use of unauthorized LLMs (ChatGPT, Claude, etc.)',
          'Mitigation Strategies: sanctioned vs. unsanctioned AI tools, browser-level controls, and Data Loss Prevention (DLP)',
          'Vulnerability Management: managing "Prompt Injection" and "Model Inversion" risks',
        ],
      },
      {
        part: '6',
        title: 'Documentation, Records & Continuous Improvement',
        topics: [
          'Record Keeping: maintaining the "Model Registry" and "Audit Trails" required by the EU AI Act',
          'Continuous Improvement (ISO Clause 10): post-market monitoring, retraining triggers, and incident response for AI "hallucinations"',
          'Board Reporting: designing the CISO/CXO AI Governance Dashboard (KPIs/KRIs)',
        ],
      },
    ],
    benefits: [
      'Ability to assess compliance obligations for Generative AI and Predictive AI under the EU AI Act and RBI guidelines',
      'Skills to identify and mitigate "Shadow AI" risks within the corporate network',
      'A drafted AI Governance Charter and Ethical AI pillars aligned with organizational values',
      'AI-specific KPIs and KRIs for continuous monitoring of model performance and bias',
      'Readiness to act as Governance Lead, overseeing the transition from "unmanaged AI sprawl" to a formal AI Management System (AIMS)',
    ],
  },
  33: {
    trainerVideo: {
      url: 'https://www.youtube.com/watch?v=bd6C3LB7HE4',
      caption: "Hear from Ishan on what you'll build and catch in this training",
    },
    summary: 'Every organisation has spent twenty years hardening the operating system. Meanwhile the work moved into the browser — mail, source control, cloud consoles, finance, HR — and a browser extension sits inside that session with a privileged view of everything the user sees and types. Extensions execute beyond the reach of the same-origin policy and CSP, with no boundary against the DOM of every page visited, and their traffic leaves as ordinary authenticated HTTPS that EDR and MDM never see. This course closes that gap by making participants do both jobs: on Day 1 they build the threat — an over-permissioned extension, an exploit against a vulnerable message-passing listener, a dummy exfiltration channel, and a silent malicious auto-update. On Day 2 they are handed a classmate\'s extension and must catch it — triage it cold, reverse-engineer it through obfuscation, block it with real enterprise policy, hunt it in telemetry, and run the incident to a blast-radius report. Nothing is demonstrated that is not later detected, and nothing is detected that was not first built in the room. Every statistic taught is cited to primary literature — 16 distinct peer-reviewed and industry papers spanning 2012–2025.',
    topics: [
      'Capability as permission × host scope — why cookies alone is a nuisance and cookies + <all_urls> is a session-theft primitive across every site the user visits',
      'The four ways extensions go bad: malicious-by-design, vulnerable-but-benign, update/supply-chain, and sold-or-compromised — each built, then caught',
      'Message passing as the primary vulnerability class — from DoubleX (CCS\'21) through CoCo (CCS\'23) to CodeX (CODASPY\'25), which tracked 212 privacy-violating extensions affecting up to 3.6M users',
      'Permission-free exfiltration — stealing data with no permission prompt at all, grounded in the SEE (Stealth Extension Exfiltration) research covering up to 351 million potentially affected users',
      'The silent auto-update channel as a delivery mechanism (Cyberhaven, Dec 2024; "You\'ve Changed", CCS\'20 — 143 malicious extensions across 922,684 versions)',
      'Why store trust signals are not a trust boundary — disguised extensions passing Chrome review, and Unicode homoglyph publishers clearing trademark filters today',
      'Six detection method families — static data-flow, dynamic taint, network, behavioural, external store signal, ML/LLM — and a scorecard for when each one earns its keep',
      'Enterprise control: the master ExtensionSettings policy, block-all-then-allowlist, blocked_permissions, runtime_blocked_hosts, deployed via CBCM, Windows GPO/ADMX, macOS MDM and Linux JSON',
      'Threat hunting, incident response, and blast-radius quantification for a rogue approved extension — mapped to MITRE ATT&CK T1176 (Browser Extensions)',
    ],
    requirements: [
      'Mandatory pre-course work (self-paced, ~3 hours, delivered two weeks ahead): reading pack on browser/extension architecture and MV2→MV3, a hello-world MV3 build exercise, and a lab bring-up verification script — this is what buys the room its Advanced pace',
      'Fluency reading and writing JavaScript (ES6+, closures, promises, async/await) and working confidently across Chrome DevTools (Network, Sources, breakpoints, Console, Application)',
      'Comfort authoring JSON by hand, working at the command line (node/npm, git, unzip), and solid web fundamentals (HTTP, TLS, DNS, cookies/sessions, same-origin policy)',
      'A personal or throwaway laptop you can take administrative control of — 8 GB RAM minimum (16 GB recommended), 40 GB free disk. Local admin rights are mandatory; corporate-managed laptops are strongly discouraged as MDM restrictions block unpacked extension loading and policy writes',
      'Pre-installed: Chrome or Edge (fresh throwaway profile), a virtualisation tool for the provided lab VM (VirtualBox, VMware Workstation/Fusion, Hyper-V, or UTM on Apple Silicon), Node.js LTS + npm, the crx-analyzer CLI, a code editor, unzip/7-Zip, and optionally mitmproxy',
    ],
    suitableFor: [
      'Red teamers and offensive security engineers adding browser and extension tradecraft',
      'Malware analysts and reverse engineers',
      'Detection engineers, threat hunters, and SOC L2/L3 analysts',
      'Incident responders and DFIR practitioners',
      'Application security and product security engineers',
      'Security architects, and endpoint / browser platform owners',
      'Enterprise IT and workspace administrators running managed Chrome or Edge fleets (CBCM, Intune, MDM)',
      'Security researchers, bug bounty hunters, and CTI analysts tracking supply-chain and extension-borne threats',
    ],
    whatToExpect: [
      'A lab-first course — 8 hands-on labs plus a live capstone, roughly 56% of class time at the keyboard',
      'To build, not just watch: you will personally write an over-permissioned extension, exploit a vulnerable message-passing listener, ship a silent malicious update, and reverse-engineer obfuscated code',
      'To defend what was built — every offensive technique is closed with the control that detects or blocks it, authored and verified by you',
      'The peer-artifact loop: on Day 2 you triage a classmate\'s extension cold, and someone triages yours',
      'Real enterprise policy work — ExtensionSettings authored and verified across Windows, macOS and CBCM',
      'Evidence, not assertion — every statistic is cited to primary literature, with live case studies including a 1,000,000-user permission-free exfiltration campaign',
      'Take-home artifacts that work on Monday — policy templates, a risk-scoring rubric, hunt queries, an IR one-pager, and a 90-day governance roadmap drafted in class',
      'A small cohort with direct trainer access, vendor-neutral content throughout',
    ],
    whatNotToExpect: [
      'Not a beginner course — no JavaScript, HTTP, or web-security fundamentals are taught; see the prerequisites',
      'No weaponised tooling — every artifact built is benign by construction (visible actions, dummy data, localhost-only egress); lab code must never be extended into real offensive capability',
      'Not browser exploit development — no V8/renderer 0-days, no sandbox escapes, no memory corruption; this is about the extension privilege surface, not Chromium vulnerability research',
      'No live targets — nothing runs against real sites, real accounts, or third-party Chrome Web Store extensions; isolated lab only',
      'Not a certification — a certificate of completion is issued, but there is no exam or accredited credential',
      'Not full cross-browser coverage — Chromium (Chrome and Edge) is the focus; Firefox and Safari are contrasted only where the models meaningfully differ',
      'No bespoke consulting on your organisation\'s specific environment, and no recording or streaming of sessions by participants',
    ],
    whatYouWillReceive: [
      'Two weeks before: pre-course reading pack, the hello-world MV3 build exercise, the lab VM image and setup scripts, and joining instructions',
      'Participant Workbook and a Hands-On Lab & Demo Guide with full procedures, worksheets and answer keys for all 8 labs and the capstone',
      'Complete slide decks for both days, the sample-extensions/ bundle, and the Capability-to-Risk mapping table used throughout the course',
      'Full source for every lab artifact, including your own Day 1 builds',
      'ExtensionSettings policy templates (CBCM JSON, Windows ADMX/GPO, macOS plist/MDM, Linux JSON), an Extension Risk-Scoring Rubric, vetting and hardening checklists',
      'An IR one-pager, blast-radius report template, hunt query pack for CBCM/EDR/proxy-DNS telemetry, and a lab troubleshooting reference',
      'A 90-day governance roadmap template completed in class, an annotated bibliography of every underlying paper, a certificate of completion, and 90 days of post-course email support',
    ],
    trainingStructure: [
      {
        part: '1',
        title: 'Day 1 — Offence: Build the Threat',
        topics: [
          'M1: The browser is the new endpoint — root primitive, rules of engagement and authorisation',
          'Lab 0: Lab bring-up & verification',
          'M2 + Lab 1: Capability = permission × host scope — dissect a .crx, enumerate permissions, produce 5 red flags',
          'M3 + Lab 2: How extensions go bad (the four-way taxonomy) — build an over-permissioned extension that reads a mock login DOM, enumerates cookies, and exfiltrates dummy data, pairing each capability with its detecting control',
          'M4: Exfiltration channels, obfuscation & anti-analysis — and why behavioural detection still wins',
          'Lab 3: Message-passing exploitation — drive an intentionally-vulnerable extension from an attacker-controlled page to reach privileged capability (the DoubleX vulnerability class, by hand)',
          'M5: Permission-free exfiltration — the 1M-user case study: storage-only permission, MAIN-world injection, an invisible iframe, and a 14-second self-destruct',
          'Lab 4: Ship a malicious update — publish a benign v1.0, then push v1.1 with escalated permissions and watch the fleet take it silently (the Cyberhaven pattern, reproduced)',
          'M6: Beyond extensions — Web Push, WebRTC as a MITM primitive, WASM payloads, fingerprinting, and AI/agentic browser assistants as the emerging 2026 surface',
          'Day 1 close & handoff — extensions are collected, anonymised and shuffled for Day 2',
        ],
      },
      {
        part: '2',
        title: 'Day 2 — Defence: Catch It, Contain It, Govern It',
        topics: [
          'M7: Detection science — six method families (static data-flow, dynamic taint, network, behavioural, external store signal, ML/LLM) and a scorecard of scale vs. precision vs. recall',
          'Lab 5: Triage a suspicious extension — handed a classmate\'s build cold, run permissions review, static skim, DevTools egress observation, and produce a weighted-rubric written verdict',
          'M8: Deobfuscation & reverse engineering for defenders — unpacking, beautifying, AST analysis, source-to-sink tracing, handling WASM',
          'Lab 6: Reverse-engineer an obfuscated extension — determine the true behaviour of a minified, packed and eval\'d sample, including a string-array rotation obfuscation concealing a C2 call',
          'M9: Enterprise controls & browser hardening — the master ExtensionSettings policy, block-all-then-allowlist, blocked_permissions, runtime_blocked_hosts',
          'Lab 7: Lock down a browser fleet — author and deploy policy that specifically blocks the extension you built yesterday; verify on chrome://policy across Windows, macOS and CBCM',
          'M10: Detection engineering & threat hunting — CBCM extension reporting, EDR, proxy/DNS egress; hunt hypotheses for beaconing, permission escalation and off-store installs',
          'Capstone: An Extension Goes Rogue — a tabletop-and-live-lab under time pressure where teams detect, validate, scope, contain, eradicate, recover, and produce a blast-radius report against timed injects',
          'M11: Governance & the 90-day roadmap — vetting pipeline, continuous discovery, and a now/30/60/90 plan each participant writes for their own organisation',
        ],
      },
    ],
    benefits: [
      'Map any extension\'s permissions and host scope to concrete capability, and defend the verdict in writing',
      'Recognise the vulnerable-message-passing class in code review before it ships',
      'Reverse-engineer a minified, packed or obfuscated extension to its true behaviour',
      'Author, deploy and verify enterprise browser policy that actually blocks a specific threat',
      'Build hunt hypotheses and detections for extension abuse against real telemetry sources',
      'Run the full incident-response cycle for a compromised approved extension and quantify the blast radius',
      'Stand up a continuous extension governance programme rather than a one-off cleanup',
    ],
  },
};
